<template>
    <div style="background: #F2F2F2;">
        <div class="passengers">
            <div class="container-fluid passenger-pd">
                <div class="containers mtop pt-20 pb-20">
                    <div class="row" style="position: relative; min-height: 100vh;">
                        <div class="col-lg-7 col-md-7 col-sm-12">
                            <div class="borderround"
                                style="border: 1px solid #DADDE1; padding: 1rem; border-radius: 8px;">
                                <div class="title-booking-detail">
                                    <p @click="checkName()" style="margin-bottom: 0%; padding-bottom: 10px;">{{
                                        $t('message.passengerDetail')
                                    }}</p>
                                </div>

                                <div v-for="(seat, index) in seatLabels" :key="seat">
                                    <div>
                                        <div class="passDetails">
                                            <div class="title-pass">{{ $t('message.passenger') }} {{ index + 1 }}: <span
                                                    style="color: #2296F3;">#{{ seat }}</span></div>
                                        </div>
                                    </div>
                                    <div style="margin: 0px 0px 24px 0px;">
                                        <div class="equals_input">
                                            <div class="gender-radios"
                                                style="display:flex; align-items:center; gap:24px;">
                                                <label style="cursor: pointer;"
                                                    :class="{ 'custom-radio': showAlertfields && !selected[index] }">
                                                    <input type="radio" :name="'gender-' + index" :value="2"
                                                        v-model.number="selected[index]"
                                                        @change="setGender(index, 2)" />
                                                    <span style="padding-left: 6px;">{{ $t('message.Female') }}</span>
                                                </label>

                                                <label style="cursor: pointer;"
                                                    :class="{ 'custom-radio': showAlertfields && !selected[index] }">
                                                    <input type="radio" :name="'gender-' + index" :value="1"
                                                        v-model.number="selected[index]"
                                                        @change="setGender(index, 1)" />
                                                    <span style="padding-left: 6px;">{{ $t('message.male') }}</span>
                                                </label>
                                            </div>


                                        </div>
                                    </div>
                                    <div>
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-12"
                                                style="padding: 5px 10px 12px 10px;">
                                                <div class="group-form">
                                                    <!-- <label for="" class="hide-label equal_label">{{
                                                        $t('message.fullName') }} <span
                                                            style="color: #FF0000; padding-left: 1px;"> *</span></label> -->
                                                    <input type="text" v-model="fullname[index]"
                                                        @input="autoFieldToBack(index)"
                                                        class="custom-input equals_input"
                                                        :class="{ 'border-radius': showAlertfields && fullname[index] === '' }"
                                                        :placeholder="$t('message.enterYourfullName')"
                                                        style="color: #545454;">
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-12"
                                                style="padding: 5px 10px 12px 10px;">
                                                <div class="group-form">
                                                    <!-- <label for="" class="hide-label equal_label">{{
                                                        $t('message.nationality') }}<span
                                                            style="color: #FF0000; padding-left: 1px;"> *</span></label> -->
                                                    <!-- nationality one way -->
                                                    <div class="equals_input" style="position: relative;">
                                                        <div style="position: relative; display: flex; align-items: center;"
                                                            class="nationality-dropdown">
                                                            <input @click="selectNation(index)" @input="filterNations"
                                                                type="text" v-model="nationality[index]"
                                                                class="custom-input"
                                                                :class="{ 'border-radius': showAlertfields && (!nationality[index] || nationality[index].trim() === ''), 'is-invalid': is_register && $v.nationality.$error }"
                                                                :placeholder="$t('message.selectNationality')"
                                                                style="flex: 1; color: #545454;" />
                                                            <i @click="selectNation(index)"
                                                                style="position: absolute; right: 12px; color: #949494; cursor: pointer; pointer-events: all;"
                                                                class="fa-solid fa-chevron-down"></i>

                                                            <!-- Custom Dropdown -->
                                                            <div v-show="showListDataNation && activeNationalityItem === index"
                                                                style="position: absolute;width: 100%;background: #fff;z-index: 10;border: 1px solid #6E6E73;border-radius: 4px; height: 200px; overflow: auto; top: 100%;">
                                                                <div v-for="(nation, i) in filteredNations" :key="i"
                                                                    @click="setNational(index, nation.id, nation.name)"
                                                                    class="hover-color"
                                                                    style="margin: 10px 0; cursor: pointer; padding-left: 12px; padding-top: 5px; padding-bottom: 5px;">
                                                                    {{ nation.name }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="dotted"><img style="width: 100%;" src="@/assets/line.png"
                                                    alt=""></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row rowScreen passenger" style="height:auto;">
                                    <div class="col-lg-12 col-md-12 col-sm-12" style="padding: 10px 10px;">
                                        <div style="display: flex; justify-content: space-between;">
                                            <label for="" class="equal_label1">{{ $t('message.boardingPoint') }} <span
                                                    style="color: #FF0000;" v-if="boardingPoint.length != 1"> *</span>
                                            </label>
                                            <a v-if="lats && longs" @click.stop="navigateToMap(lats, longs)"
                                                style=" font-weight: 400; color: #FFA733; font-style: italic; cursor: pointer;">
                                                {{ $t('message.viewMap') }}
                                            </a>
                                        </div>
                                        <div variant="outlined" readonly class="custom-select" :tabindex="tabindex">
                                            <div class="selected"
                                                :class="{ 'border-radius': showAlertfields && boardingPoint.length !== 1 && selectedBoxname == '', hideAfterdrop: boardingPoint.length === 1, open: open }"
                                                @click="open = !open">
                                                <div style="display: flex; gap: 10px;">
                                                    <i class="fa-solid fa-location-dot"
                                                        style="color: #545454; padding-top: 5px;"></i>
                                                    <div style="font-weight: 600;">
                                                        {{ selectedBoxname }}
                                                        <!-- <div class="mobileScreen" style="color: #545454; width: max-content;">
                                                            {{ selectedBox == "" ? this.$t('message.boardingPoint') : selectedBox }}
                                                        </div> -->
                                                        <div v-if="selectedBox == ''" class="mobileScreen"
                                                            style="color: #545454; width: max-content;">
                                                            {{ this.$t('message.boardingPoint') }}
                                                        </div>
                                                        <div v-else class="mobileScreen"
                                                            style="color: #545454; padding-top: 6px;">{{ selectedBox }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <i style="color: #949494; cursor: pointer;"
                                                    v-if="boardingPoint.length > 1" :class="{ open: open }"
                                                    @click.stop="open = !open" class="fa-solid fa-chevron-down"></i>
                                            </div>

                                            <div class="items" :class="{ selectHide: !open }"
                                                v-if="boardingPoint.length != 1">
                                                <div class="header-drop-point"> {{ $t('message.boardingPoint') }}
                                                </div>
                                                <div class="d-flex mb-3" v-for="point in boardingPoint" :key="point.id"
                                                    @click="point.isAllow === 1 && storeData(pointName = point.address, pointId = point.id),
                                                        point.isAllow === 1 && (selectedBox = point.address),
                                                        point.isAllow === 1 && (selectedBoxname = point.name + ' ' + convertTimes(point.time)),
                                                        point.isAllow === 1 && (lats = point.lats),
                                                        point.isAllow === 1 && (longs = point.longs),
                                                        point.isAllow === 1 && (open = false),
                                                        point.isAllow === 1 && $emit('input', point.name)"
                                                    :class="{ 'disabled-point': point.isAllow !== 1 }">
                                                    <div class="checkbox-mobile"
                                                        style="margin-left: -9px; margin-right: 30px;">
                                                        <label class="custom-checkbox">
                                                            <input type="checkbox" disabled
                                                                :checked="selectedCheckbox == point.id"
                                                                :value="point.id"
                                                                :class="{ 'disabled-checkbox': point.isAllow !== 1 }"
                                                                style="color: #545454;">
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                    <div class="right-info-name-map">
                                                        <div class="d-flex justify-space-between"
                                                            :class="{ 'disabled-content': point.isAllow !== 1 }"
                                                            style="padding-bottom: 8px;">
                                                            <div class="name-width">
                                                                <span style="color: #E38F5A; font-weight: 600;">{{
                                                                    point.name }} {{ convertTimes(point.time)
                                                                    }}</span>
                                                            </div>
                                                            <div v-if="point.isAllow === 1" class="map-point-width">
                                                                <a @click.stop="navigateToMap(lats, longs)"
                                                                    style=" font-weight: 400; color: #FFA733; font-style: italic; cursor: pointer; ">
                                                                    {{ $t('message.viewMap') }}
                                                                </a>
                                                            </div>
                                                            <div v-else class="map-point-width-left">
                                                                <a
                                                                    style="text-decoration: underline; padding-right: 2px; font-weight: 600; color: #312783; text-align: end;">{{
                                                                        $t('message.left') }}</a>
                                                            </div>

                                                        </div>
                                                        <div :class="{ 'disabled-content': point.isAllow !== 1 }"
                                                            style="width:95%; margin-left: -12px;">
                                                            <p style="color: #20292F; font-size: 14px;">{{ point.address
                                                                }}</p>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="pt-4" style="display: flex;">
                                            <img class="" src="@/assets/passenger_info/exclamation.svg" alt="">
                                            <span style="line-height: 1.5; color: #312783; font-size: 12px;">
                                                {{ $t('message.desBoardingPointNight') }}</span>
                                        </div>
                                    </div>


                                </div>
                                <div class="row passenger"
                                    style="margin-bottom: auto !important; padding-top: 0px !important; height:auto;">
                                    <div class="col-lg-12 col-md-12 col-sm-12" style="padding: 10px 10px;">
                                        <div style="display: flex; justify-content: space-between;">
                                            <label for="" class="equal_label1">{{ $t('message.dropOffPoint') }} <span
                                                    style="color: #FF0000;" v-if="dropOffPoint.length != 1">
                                                    *</span></label>
                                            <a v-if="latsdropoff && longsdropoff"
                                                @click.stop="navigateToMap(latsdropoff, longsdropoff)"
                                                style=" font-weight: 400; color: #FFA733; font-style: italic; cursor: pointer;">
                                                {{ $t('message.viewMap') }}
                                            </a>
                                        </div>

                                        <div class="custom-select" :tabindex="tabindex">
                                            <div class="selected"
                                                :class="{ 'border-radius': showAlertfields && dropOffPoint.length !== 1 && selectedBoxDownname == '', hideAfterdrop: dropOffPoint.length == 1, open1: open1 }"
                                                @click="!loadingDropOffPoints && (open1 = !open1)">
                                                <div style="display: flex; gap: 10px;">
                                                    <i class="fa-solid fa-location-dot"
                                                        style="color: #545454; padding-top: 5px;"></i>
                                                    <div>
                                                        <div v-if="loadingDropOffPoints"
                                                            style="display: flex; align-items: center; gap: 8px;">
                                                            <div class="loader" style="width: 16px; height: 16px;">
                                                            </div>
                                                            <span style="color: #545454;">Loading drop-off
                                                                points...</span>
                                                        </div>
                                                        <div style="font-weight: 600;" v-else>
                                                            {{ selectedBoxDownname }}
                                                            <!-- <div class="mobileScreen" style="color: #545454; width: max-content;">
                                                                {{ selectedBoxDown == "" ? this.$t('message.dropOffPoint')
                                                                    :
                                                                    selectedBoxDown }}
                                                            </div> -->
                                                            <div v-if="selectedBoxDown == ''" class="mobileScreen"
                                                                style="color: #545454; width: max-content;">
                                                                {{ this.$t('message.dropOffPoint') }}
                                                            </div>
                                                            <div v-else class="mobileScreen"
                                                                style="color: #545454; padding-top: 6px;">
                                                                {{ selectedBoxDown }}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <i style="color: #949494; cursor: pointer;"
                                                    v-if="dropOffPoint.length > 1" :class="{ open: open1 }"
                                                    @click.stop="open1 = !open1" class="fa-solid fa-chevron-down"></i>

                                            </div>
                                            <div class="items" :class="{ selectHide: !open1 }"
                                                v-if="dropOffPoint.length != 1">
                                                <div class="header-drop-point"> {{ $t('message.dropOffPoint') }}t
                                                </div>
                                                <div class="d-flex mb-3" v-for="dropoff in dropOffPoint"
                                                    :key="dropoff.id" @click="storeDataDown(pointNameDown = dropoff.address,
                                                        pointIdDown = dropoff.id),
                                                        selectedBoxDown = dropoff.address + ' ';
                                                    selectedBoxDownname = dropoff.name + ' - ' + convertTimes(dropoff.time);
                                                    latsdropoff = dropoff.lats;
                                                    longsdropoff = dropoff.longs;
                                                    open1 = false; $emit('input', dropoff.name);">
                                                    <div class="checkbox-mobile"
                                                        style="margin-left: -9px; margin-right: 30px;">
                                                        <label class="custom-checkbox">
                                                            <input type="checkbox" disabled
                                                                :checked="selectedCheckboxDown == dropoff.id"
                                                                :value="dropoff.id" style="color: #545454;">
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                    <div class="right-info-name-map">
                                                        <div class="d-flex justify-space-between"
                                                            style="padding-bottom: 8px;">
                                                            <div class="name-width">
                                                                <span style="color: #E38F5A; font-weight: 600;">{{
                                                                    dropoff.name }} {{ convertTimes(dropoff.time)
                                                                    }}</span>
                                                            </div>
                                                            <div class="map-point-width">
                                                                <a @click.stop="navigateToMap(latsdropoff, longsdropoff)"
                                                                    style=" font-weight: 400; color: #FFA733; font-style: italic; cursor: pointer;">
                                                                    {{ $t('message.viewMap') }}
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div style="width:95%; margin-left: -12px;">
                                                            <p style="color: #20292F; font-size: 14px;">{{
                                                                dropoff.address }}</p>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- round trip -->
                            <div v-if="returnTrip" style="padding: 2rem 0rem 0rem 0rem;">
                                <div class="borderround"
                                    style="border: 1px solid #DADDE1; padding: 1rem; border-radius: 8px;">
                                    <div class="passDetails-info">
                                        <div class="passenger" style="padding-top: 0%;">
                                            <div class="title-booking-detail">
                                                <p @click="checkName()"
                                                    style="margin-bottom: 0%; padding-bottom: 10px;">{{
                                                        $t('message.returnTrip')
                                                    }}</p>
                                            </div>
                                            <div style="">
                                                <div v-for="(seat, index) in seatLabelbacks" :key="seat.id">
                                                    <div>
                                                        <div class="passDetails">
                                                            <div class="title-pass">{{ $t('message.passenger') }} {{
                                                                index + 1 }}: <span style="color: #2296F3;">#{{
                                                                    seatLabelbacks[index] }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style="margin: 0px 0px 24px 0px;">
                                                        <div style="margin: 0px 0px 24px 0px;">
                                                            <div class="equals_input">

                                                                <div class="gender-radios"
                                                                    style="display:flex; align-items:center; gap:24px;">
                                                                    <label
                                                                        :class="{ 'custom-radio': showAlertfields && !selectedback[index] }"
                                                                        style="display:flex; align-items:center; gap:8px; cursor:pointer;">
                                                                        <input type="radio"
                                                                            :name="'gender-back-' + index" :value="2"
                                                                            v-model.number="selectedback[index]"
                                                                            @change="setGenderBack(index, 2)" />
                                                                        {{ $t('message.Female') }}
                                                                    </label>
                                                                    <label
                                                                        :class="{ 'custom-radio': showAlertfields && !selectedback[index] }"
                                                                        style="display:flex; align-items:center; gap:8px; cursor:pointer;">
                                                                        <input type="radio"
                                                                            :name="'gender-back-' + index" :value="1"
                                                                            v-model.number="selectedback[index]"
                                                                            @change="setGenderBack(index, 1)" />
                                                                        {{ $t('message.male') }}
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            <!-- 
                                                            <div class="gender-radios"
                                                style="display:flex; align-items:center; gap:24px;">
                                                <label :class="{ 'custom-radio': showAlertfields && !selected[index] }">
                                                    <input type="radio" :name="'gender-' + index" :value="2"
                                                        v-model.number="selected[index]"
                                                        @change="setGender(index, 2)" />
                                                    <span style="padding-left: 6px;">{{ $t('message.Female') }}</span>
                                                </label>

                                                <label :class="{ 'custom-radio': showAlertfields && !selected[index] }">
                                                    <input type="radio" :name="'gender-' + index" :value="1"
                                                        v-model.number="selected[index]"
                                                        @change="setGender(index, 1)" />
                                                    <span style="padding-left: 6px;">{{ $t('message.male') }}</span>
                                                </label>
                                            </div> -->
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 col-sm-12"
                                                            style="padding: 5px 10px 12px 10px;">
                                                            <div class="group-form">
                                                                <!-- <label for="" class="hide-label equal_label">{{
                                                                    $t('message.fullName') }}<span
                                                                        style="color: #FF0000; padding-left: 1px;">
                                                                        *</span></label> -->
                                                                <input type="text" v-model="fullnameback[index]"
                                                                    @click="myChangeFunction(index)"
                                                                    class="custom-input equals_input"
                                                                    :class="{ 'border-radius': showAlertfields && fullnameback[index] === '' }"
                                                                    :placeholder="$t('message.enterYourfullName')"
                                                                    style="color: #545454;">
                                                            </div>
                                                        </div>
                                                        <!-- return trip nationality -->
                                                        <div class="col-lg-6 col-md-6 col-sm-12"
                                                            style="padding: 5px 10px 12px 10px;">
                                                            <div class="group-form">
                                                                <!-- <label for="" class="hide-label equal_label">{{
                                                                    $t('message.nationality') }}<span
                                                                        style="color: #FF0000; padding-left: 1px;">
                                                                        *</span></label> -->
                                                                <div class="equals_input" style="position: relative;">
                                                                    <div style="position: relative; display: flex; align-items: center;"
                                                                        class="nationality-dropdown">

                                                                        <input @click="selectNation(index, true)"
                                                                            @input="filterNations" type="text"
                                                                            v-model="nationalityBack[index]"
                                                                            :class="{ 'is-invalid': is_register && $v.nationality.$error, 'border-radius': showAlertfields && nationalityBack[index] === '' }"
                                                                            class="custom-input"
                                                                            style="color: #545454; flex: 1;"
                                                                            :placeholder="$t('message.selectNationality')" />
                                                                        <i @click="selectNation(index, true)"
                                                                            style="position: absolute; right: 12px; color: #949494; cursor: pointer; pointer-events: all;"
                                                                            class="fa-solid fa-chevron-down"></i>

                                                                        <!-- Custom Dropdown -->
                                                                        <div v-show="showListDataNation && activeNationalityItemBack === index"
                                                                            style="position: absolute;width: 100%;background: #fff;z-index: 10;border: 1px solid #6E6E73;border-radius: 4px; height: 200px; overflow: auto; top: 100%;">
                                                                            <div v-for="(nation, i) in filteredNations"
                                                                                :key="i"
                                                                                @click="setNational(index, nation.id, nation.name, true)"
                                                                                class="hover-color"
                                                                                style="margin: 10px 0; cursor: pointer; padding-left: 12px; padding-top: 5px; padding-bottom: 5px;">
                                                                                {{ nation.name }}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="returnTrip" style="padding-top: 30px;">
                                        <div class="row passenger"
                                            style=" margin-bottom: auto !important; padding-top: 0px !important; height:auto;">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <div style="display: flex; justify-content: space-between;">
                                                    <label for="" class="equal_label1">{{ $t('message.boardingPoint') }}
                                                        <span style="color: #FF0000;"
                                                            v-if="boardingPointBack.length != 1">
                                                            *</span></label>
                                                    <a v-if="latspointBack && longsPointBack"
                                                        @click.stop="navigateToMap(latspointBack, longsPointBack)"
                                                        style="font-weight: 400; color: #FFA733; cursor: pointer; font-style: italic;">{{
                                                            $t('message.viewMap') }}</a>
                                                </div>

                                                <div class="custom-select" :tabindex="tabindex">
                                                    <div class="selected"
                                                        :class="{ 'border-radius': showAlertfields && boardingPointBack.length !== 1 && selectedBoxBackDownname === '', hideAfterdrop: boardingPointBack.length == 1, open2: open2 }"
                                                        @click="open2 = !open2">
                                                        <div style="display: flex; gap: 10px; flex: 1;">
                                                            <i class="fa-solid fa-location-dot"
                                                                style="color: #545454; padding-top: 5px;"></i>
                                                            <div style="font-weight: 600;">
                                                                {{ selectedBoxBackDownname }}
                                                                <!-- <div class="mobileScreen" style="color: #545454; width: max-content;">
                                                                    {{ selectedBoxBack == '' ?
                                                                        this.$t('message.boardingPoint') :
                                                                        selectedBoxBack }}
                                                                </div> -->
                                                                <div v-if="selectedBoxBack == ''" class="mobileScreen"
                                                                    style="color: #545454; width: max-content;">
                                                                    {{ this.$t('message.boardingPoint') }}
                                                                </div>
                                                                <div v-else class="mobileScreen"
                                                                    style="color: #545454; padding-top: 6px;">
                                                                    {{ selectedBoxBack }}
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <i style="color: #949494; cursor: pointer;"
                                                            v-if="boardingPointBack.length > 1" :class="{ open: open2 }"
                                                            @click.stop="open2 = !open2"
                                                            class="fa-solid fa-chevron-down"></i>
                                                    </div>

                                                    <div class="items" :class="{ selectHide: !open2 }"
                                                        v-on:click="open2 = false" v-if="boardingPointBack.length != 1">
                                                        <div class="header-drop-point"> {{ $t('message.boardingPoint')
                                                        }}
                                                        </div>
                                                        <div class="d-flex mb-3" v-for="pointBack in boardingPointBack"
                                                            :key="pointBack.id" @click="pointBack.isAllow === 1 && storeDataBack(pointName = pointBack.address, pointId = pointBack.id),
                                                                pointBack.isAllow === 1 && (selectedBoxBackDownname = pointBack.name + ' ' + convertTimes(pointBack.time)),
                                                                pointBack.isAllow === 1 && (selectedBoxBack = pointBack.address),
                                                                pointBack.isAllow === 1 && (latspointBack = pointBack.lats),
                                                                pointBack.isAllow === 1 && (longsPointBack = pointBack.longs),
                                                                pointBack.isAllow === 1 && (open2 = false)"
                                                            :class="{ 'disabled-point': pointBack.isAllow !== 1 }">
                                                            <div class="checkbox-mobile"
                                                                style="margin-left: -9px; margin-right: 30px;">
                                                                <label class="custom-checkbox">
                                                                    <input type="checkbox" disabled
                                                                        :checked="selectedCheckboxBack == pointBack.id"
                                                                        :value="pointBack.id"
                                                                        :class="{ 'disabled-checkbox': pointBack.isAllow !== 1 }"
                                                                        style="color: #545454;">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <div class="right-info-name-map">
                                                                <div class="d-flex justify-space-between"
                                                                    :class="{ 'disabled-content': pointBack.isAllow !== 1 }"
                                                                    style="padding-bottom: 8px;">
                                                                    <div class="name-width">
                                                                        <span
                                                                            style="color: #E38F5A; font-weight: 600;">{{
                                                                                pointBack.name }} {{
                                                                                convertTimes(pointBack.time) }}</span>
                                                                    </div>
                                                                    <div v-if="pointBack.isAllow === 1"
                                                                        class="map-point-width">
                                                                        <a @click.stop="pointBack.isAllow === 1 && navigateToMap(pointBack.lats, pointBack.longs),
                                                                            pointBack.isAllow === 1 && (open2 = true)"
                                                                            style=" font-weight: 400; color: #FFA733; cursor: pointer; font-style: italic;">{{
                                                                                $t('message.viewMap') }}</a>
                                                                    </div>
                                                                    <div v-else class="map-point-width-left">
                                                                        <a style=" font-weight: 600; color: #FFA733;">{{
                                                                            $t('message.left') }}</a>
                                                                    </div>
                                                                </div>
                                                                <div :class="{ 'disabled-content': pointBack.isAllow !== 1 }"
                                                                    style="width:95%; margin-left: -12px;">
                                                                    <p style="color: #20292F; font-size: 14px;">{{
                                                                        pointBack.address }}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div class="pl-3 pb-1 " style="display: flex;">
                                                <img class="" src="@/assets/passenger_info/exclamation.svg" alt="">
                                                <span
                                                    style="line-height: 1.5; color: #312783; font-size: 12px; font-style: Light;">
                                                    {{ $t('message.desBoardingPointNight') }}</span>
                                            </div> -->
                                                <div class="pt-4" style="display: flex;">
                                                    <img class="" src="@/assets/passenger_info/exclamation.svg" alt="">
                                                    <span style="line-height: 1.5; color: #312783; font-size: 12px;">
                                                        {{ $t('message.desBoardingPointNight') }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row passenger"
                                            style="padding-top: 0px !important; margin-top: 0px !important; margin-bottom: auto !important; height:auto;">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <div style="display: flex; justify-content: space-between;">
                                                    <label for="" class="equal_label1">{{ $t('message.dropOffPoint')
                                                    }}<span style="color: #FF0000;"
                                                            v-if="dropOffPointBack.length != 1">
                                                            *</span> </label>
                                                    <a v-if="latspointBackoff && longsPointBackoff"
                                                        @click.stop="navigateToMap(latspointBackoff, longsPointBackoff)"
                                                        style=" font-weight: 400; color: #FFA733; cursor: pointer; font-style: italic;">{{
                                                            $t('message.viewMap') }}</a>
                                                </div>

                                                <div class="custom-select" :tabindex="tabindex">
                                                    <div class="selected"
                                                        :class="{ 'border-radius': showAlertfields && dropOffPointBack.length !== 1 && selectedBoxBackoffDownname == '', hideAfterdrop: dropOffPointBack.length == 1, open3: open3 }"
                                                        @click="open3 = !open3">
                                                        <div style="display: flex; gap: 10px; flex: 1;">
                                                            <i class="fa-solid fa-location-dot"
                                                                style="color: #545454; padding-top: 5px;"></i>
                                                            <div style="font-weight: 600;">
                                                                {{ selectedBoxBackoffDownname }}
                                                                <!-- <div class="mobileScreen" style="color: #545454; width: max-content;">
                                                                    {{ selectedBoxBackoffDown == '' ?
                                                                        $t('message.dropOffPoint') :
                                                                        selectedBoxBackoffDown }}
                                                                </div> -->
                                                                <div v-if="selectedBoxBackoffDown == ''"
                                                                    class="mobileScreen"
                                                                    style="color: #545454; width: max-content;">
                                                                    {{ this.$t('message.dropOffPoint') }}
                                                                </div>
                                                                <div v-else class="mobileScreen"
                                                                    style="color: #545454; padding-top: 6px;">
                                                                    {{ selectedBoxBackoffDown }}
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <i style="color: #949494; cursor: pointer;"
                                                            v-if="dropOffPointBack.length > 1" :class="{ open: open3 }"
                                                            @click.stop="open3 = !open3"
                                                            class="fa-solid fa-chevron-down"></i>


                                                    </div>

                                                    <div class="items" :class="{ selectHide: !open3 }"
                                                        v-if="dropOffPointBack.length != 1">
                                                        <div class="header-drop-point"> {{ $t('message.dropOffPoint') }}
                                                            <span style="color: #FF0000;"
                                                                v-if="dropOffBack.length != 1">
                                                                *</span>
                                                        </div>
                                                        <!-- boreyitem -->
                                                        <div class="d-flex mb-3" v-for="dropOffBack in dropOffPointBack"
                                                            :key="dropOffBack.id" @click="storeDataBackDown(pointName = dropOffBack.address, pointId = dropOffBack.id),
                                                                selectedBoxBackoffDown = dropOffBack.address + ' ';
                                                            latspointBackoff = dropOffBack.lats;
                                                            longsPointBackoff = dropOffBack.longs;
                                                            selectedBoxBackoffDownname = dropOffBack.name + ' ' + convertTimes(dropOffBack.time);
                                                            open3 = false">
                                                            <div class="checkbox-mobile"
                                                                style="margin-left: -9px; margin-right: 30px;">
                                                                <label class="custom-checkbox">
                                                                    <input type="checkbox" disabled
                                                                        :checked="selectedCheckboxBackDown == dropOffBack.id"
                                                                        :value="dropOffBack.id" style="color: #545454;">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <div class="right-info-name-map">
                                                                <div class="d-flex justify-space-between"
                                                                    style="padding-bottom: 8px;">
                                                                    <div class="name-width">
                                                                        <span
                                                                            style="color: #E38F5A; font-weight: 600;">{{
                                                                                dropOffBack.name }} {{
                                                                                convertTimes(dropOffBack.time) }}</span>
                                                                    </div>
                                                                    <div class="map-point-width">
                                                                        <a @click.stop="navigateToMap(dropOffBack.lats, dropOffBack.longs), open3 = true;"
                                                                            style="font-weight: 400; color: #FFA733; cursor: pointer; font-style: italic;">{{
                                                                                $t('message.viewMap') }}</a>
                                                                    </div>
                                                                </div>
                                                                <div style="width:95%; margin-left: -12px;">
                                                                    <p style="color: #20292F; font-size: 14px;">{{
                                                                        dropOffBack.address }}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="padding: 2rem 0rem 0rem 0rem;">
                                <div class="" style="border: 1px solid #DADDE1; padding: 1rem; border-radius: 8px;">
                                    <div>
                                        <h2 class=""
                                            style="color: #20292F !important; padding: 6px 0px; font-weight: 600; font-size: 16px;">
                                            {{
                                                $t('message.contactdetails')
                                            }}</h2>
                                        <span class="pl-2"
                                            style="border-left: 3px solid #FFA733; border-radius: 3px;">{{
                                                $t('message.yourBookingDetailticketWillBeSent') }}</span>
                                    </div>
                                    <div class="row passenger">
                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                            <div class="group-form1">
                                                <input type="email" v-model="email" @input="validateEmailRealTime"
                                                    class="custom-input"
                                                    :class="{ 'border-radius': shouldHighlightEmailField }"
                                                    style="padding: 10px 12px; margin-top: 5px; color: #545454;"
                                                    :placeholder="contactPlaceholder">
                                                <!-- <span v-if="msg.email" style="color: #FF0000;">{{ msg.email }}</span> -->
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                            <div class="group-form1" style=" display: flex; flex-direction: column;">
                                                <input type="tel" v-model="phone" @input="validatePhoneNumber($event.target.value)"
                                                    @keypress="onlyNumber($event)" @paste="handlePaste($event)"
                                                    class="custom-input"
                                                    :class="{ 'border-radius': shouldHighlightPhoneField }"
                                                    style="padding: 10px 12px; margin-top: 5px; color: #545454;"
                                                    :placeholder="$t('message.enterTelephoneNumber')">
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div>
                                    <div class="" style="margin-top: 14px;">
                                        <div class="" style="padding: 0%; width: 100%;">
                                            <div class="noted-rq">
                                                <div class="img-note">
                                                    <div class="bg-lights">
                                                        <img src="@/assets/light.png" alt="">
                                                    </div>
                                                    <div style="font-size: 16px;font-weight: 600;color: #424245;">
                                                        {{ $t('message.noted') }} *</div>
                                                </div>
                                                <div class="noted-text">
                                                    <p style="font-size: 14px; margin-bottom:12px;" class="">{{
                                                        $t('message.attention') }}</p>
                                                    <p style="font-size: 14px; margin-bottom: 0%;">{{
                                                        $t('message.desAttention') }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="pt-4 mt-4" style="border-top: 1px solid #DADDE1; ">
                                    <div v-if="getSeat() <= 1 && (!returnTrip || (returnTrip && getSeatBack() <= 1))" style="font-size: 16px;font-weight: 600;color: #424245;">{{ $t('message.Discountcoupon') }}</div>
                                     <div v-if="!returnTrip && getSeat() > 1" style="font-size: 16px;font-weight: 600;color: #424245;">{{ $t('message.Discountcoupon') }}</div>
                                    <div v-if="getSeat() <= 1 && (!returnTrip || (returnTrip && getSeatBack() <= 1))">
                                        <div class="" style="border-bottom: 1px solid #DADDE1;;">
                                            <div style=" margin-bottom: 8px;">
                                                <div class="check-box">
                                                    <div style="margin-top: 10px; margin-left: 2px">
                                                        <label class="custom-checkbox-appy">
                                                            <input type="checkbox" v-model="isCheckPackageApply"
                                                                @change="handleCheckboxTravelPackage"
                                                                style="transform: scale(1.5);">
                                                            <span class="checkmark-appy"></span>
                                                        </label>
                                                    </div>
                                                    <div style="font-size: 14px; text-align: center; ">
                                                        {{ $t('message.travelPackageTitle') }}
                                                    </div>
                                                </div>
                                                <div style="width: 100%;" v-if="isCheckPackageApply">
                                                    <input type="text"
                                                        style="cursor: pointer; padding-left: 12px; border-radius: 4px;  width: 100%; padding-top: 10px;  padding-bottom: 10px; outline: none; border: 1px solid #DADDE1; user-select: none;"
                                                        v-model="packageCode" placeholder="Travel package code"
                                                        oncopy="return false" oncut="return false"
                                                        onpaste="return false" readonly>
                                                </div>

                                                <!-- <div class="promo-code-section">
                                                    <div class="promo-code-row" @click="openCouponModal">
                                                        <div class="promo-code-title-wrap">
                                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                                                <rect width="25" height="25" rx="4"
                                                                    fill="url(#pattern0_9580_2077)" />
                                                                <defs>
                                                                    <pattern id="pattern0_9580_2077"
                                                                        patternContentUnits="objectBoundingBox"
                                                                        width="1" height="1">
                                                                        <use xlink:href="#image0_9580_2077"
                                                                            transform="scale(0.00195312)" />
                                                                    </pattern>
                                                                    <image id="image0_9580_2077" width="512"
                                                                        height="512" preserveAspectRatio="none"
                                                                        xlink:href="data:image/png;base64,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" />
                                                                </defs>
                                                            </svg>

                                                            <span class="promo-code-title">Promo Code</span>
                                                        </div>
                                                        <p class="promo-code-inline-input"
                                                            :class="{ 'applied-code': isCouponApplied }">
                                                            {{ 'Enter promo code' }}
                                                        </p>
                                                    </div>
                                                    <input type="text" class="promo-code-input" v-model="couponCode"
                                                        :disabled="isCouponApplied" placeholder="Enter promo code"
                                                        @input="validateCouponCode" />
                                                </div> -->

                                            </div>
                                        </div>

                                    </div>
                                    <div v-if="!returnTrip"
                                        style="border-bottom: 1px solid #DADDE1;padding: 12px 0px;">
                                        <div style="display: flex; justify-content: space-between; align-items: center; cursor: pointer;"
                                            :style="isCheckPackageApply ? { cursor: 'not-allowed', opacity: 0.6, pointerEvents: 'none' } : {}"
                                            @click="openCouponModal">
                                            <div style="display: flex; justify-content: center; align-items: center;">
                                                <img style="width: 25px; height: 25px;" src="@/assets/coupons.png"
                                                    alt="">
                                                <p
                                                    style="color: #20292F; font-size: 16px; margin-bottom: 0%; padding-left: 12px;">
                                                    {{ $t('message.PromoCode') }}</p>
                                            </div>
                                            <p style="color: #6B7280; font-size: 16px; margin-bottom: 0%;">
                                                {{
                                                    $t('message.EnterpromoCode') }}</p>
                                        </div>
                                        <div style="width: 100%; padding-top: 12px; position: relative;"
                                            v-if="isCouponApplied && couponResponse">
                                            <input type="text" class="custom-input" readonly v-model="safePromoInput"
                                                style="padding-right: 40px;">
                                            <i class="fas fa-times" @click="removeCoupon"
                                                style="position: absolute; right: 12px; top: 60%; transform: translateY(-50%); cursor: pointer; color: #999; font-size: 16px; transition: color 0.2s ease;"
                                                @mouseover="$event.target.style.color = '#dc3545'"
                                                @mouseleave="$event.target.style.color = '#999'"></i>
                                        </div>
                                        <div v-if="isCouponApplied && couponResponse && couponResponse.balance"
                                            style="font-size:12px; margin-top:6px;">
                                            {{ $t('message.YourpromoCodeAvailable') }} <span>${{
                                                couponResponse.balance }}</span> {{ $t('message.more') }}.
                                        </div>
                                    </div>
                                    <!-- Coupon modal trigger added above -->

                                    <!-- coupon code  popup -->
                                    <div v-if="showCouponModal" class="promo-modal-overlay"
                                        @click.self="closeCouponModal"
                                        style="position: fixed; inset: 0; background: rgba(0,0,0,0.45); display:flex; align-items:center; justify-content:center; z-index:2000;">
                                        <div class="promo-modal"
                                            style="width:444px; max-width:92%; background:#fff; border-radius:12px; padding:24px; position:relative;">
                                            <button @click="closeCouponModal" aria-label="Close"
                                                style="position:absolute; right:16px; top:12px; border:0; background:transparent; font-size:20px; cursor:pointer;">×</button>
                                            <h3 style="margin:0 0 16px 0; font-size:20px; color:#20292F;">{{
                                                $t('message.MyOffers') }}</h3>
                                            <div
                                                style="display:flex; align-items:center; gap:12px; border: #D1D5DB solid 1px; border-radius: 25px; padding: 4px;">
                                                <input type="text" v-model="safePromoInput"
                                                    :placeholder="$t('message.EnterpromoCode')"
                                                    style="flex:1; padding:10px 16px; border:none; border-radius:20px; outline:none; font-size:16px; background:transparent;" />
                                                <button
                                                    :disabled="!promoInput || promoInput.trim() === '' || couponLoading"
                                                    @click="applyPromoFromModal" :style="{
                                                        border: '0',
                                                        background: (promoInput && promoInput.trim().length > 6) ? '#DE5D0A' : '#D9D9D9',
                                                        color: '#fff',
                                                        padding: '16px 45px',
                                                        borderRadius: '25px',
                                                        cursor: (promoInput && promoInput.trim().length > 6 && !couponLoading) ? 'pointer' : 'not-allowed',
                                                        fontWeight: 600
                                                    }">
                                                    <span v-if="couponLoading">{{ $t('message.Applying')
                                                        }}</span>
                                                    <span v-else>{{ $t('message.apply') }}</span>
                                                </button>
                                            </div>
                                            <div
                                                style="display:flex; align-items:flex-start; gap:10px; margin-top:14px; color:#6B7280;">
                                                <img style="width: 24px; height: 24px;"
                                                    src="@/assets/exclamation_copy.svg" alt="">
                                                <div style="font-size:14px; line-height:1.3;">{{
                                                    $t('message.Promotioncodevaluemustbeequaltoorhigherthantheticketprice')
                                                    }}
                                                </div>
                                            </div>
                                            <div v-if="couponError"
                                                style="display:flex; align-items:flex-start; gap:10px; margin-top:14px; color:#6B7280;">
                                                <img style="width: 24px; height: 24px;"
                                                    src="@/assets/alert-triangle.png" alt="">
                                                <div style="font-size:14px; line-height:1.3; color: #DC3545;">
                                                    <!-- {{ $t('message.Yourpromotioncode') }} {{ promoInput }} {{ $t('message.isnotvalid') }} -->
                                                    {{ couponError }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-5 col-md-5 col-sm-12 padd-lefe">
                            <!-- information seat -->
                            <div class="row"
                                style="border: 1px solid #DADDE1; border-radius: 8px; opacity: 1; z-index: 100; margin: 0%;">
                                <div class="col-lg-12 col-md-12 col-sm-12" style="padding: 1rem">
                                    <div class="fare-detail" style="border-bottom: 1px solid #DADDE1">
                                        {{ $t('message.Bookingsummary') }}
                                    </div>
                                    <div class="data-details" style="border-bottom: 1px solid #DADDE1;">
                                        <div style="padding-bottom: 1rem;">
                                            <div class="d-flexs">
                                                <div class="dynamic">
                                                    {{ getDestinationFrom() }} -
                                                    {{ getdestinationToName() }}
                                                </div>
                                            </div>
                                            <div class="d-flexs">
                                                <div class="dynamic">
                                                    {{ getDateFrom() }}
                                                </div>
                                            </div>
                                            <div class="d-flexs" style="justify-content: space-between;">
                                                <div class="static">
                                                    {{ $t('message.TicketPrice') }}
                                                </div>
                                                <div class="dynamic">
                                                    <!-- {{ getSeatLabel() || '-' }} -->
                                                    ${{ formatPrice(TripPrice()) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="returnTrip"
                                            style="border-top: 1px solid #DADDE1; padding-bottom: 1rem;">
                                            <div class="d-flexs">
                                                <div class="dynamic">
                                                    {{ getdestinationToName() }} -
                                                    {{ getDestinationFrom() }}
                                                </div>
                                            </div>
                                            <div class="d-flexs">
                                                <div class="dynamic">
                                                    {{ getDateTo() }}
                                                </div>
                                            </div>

                                            <div class="d-flexs" style="justify-content: space-between;">
                                                <div class="static">
                                                    {{ $t('message.TicketPrice') }}
                                                </div>
                                                <div class="dynamic">
                                                    ${{ formatPrice(TripPriceBack()) }}
                                                </div>
                                            </div>
                                            <div class="d-flexs" v-if="!showpriceOriginalback"
                                                style="justify-content: space-between;">
                                                <div class="static">
                                                    {{ $t('message.grandTotal') }}
                                                </div>
                                                <div class="dynamic">
                                                    ${{ formatPrice(grandTotalBack()) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="border-bottom: 1px solid #DADDE1; padding: 1rem 0;">
                                        <span @click="showTripDetailsModal"
                                            style="color: #2296F3; cursor: pointer; font-size: 14px;">
                                            {{ $t('message.viewTripDetails') }}
                                        </span>
                                    </div>
                                    <div class="data-details mt-2">
                                        <div>
                                            <div style="background: #F1AF88;" v-if="isLuckyDrawEnabled">
                                                <div class="check-box" style="justify-content: center;">
                                                    <div class="text d-flex"
                                                        style="color: #FFFFFF; font-size: 14px; width:92%;">
                                                        {{ $t('message.luckyTicketTitle') }}
                                                    </div>
                                                </div>
                                                <div class="check-box" style="justify-content: center;">
                                                    <div class="text d-flex"
                                                        style="color: #FFFFFF; width:92%; padding-bottom: 10px;">
                                                        <div style="margin-top: -10px; margin-left: 2px">
                                                            <v-checkbox color="#DE5D0A" style="transform: scale(1.5);"
                                                                v-model="isCheckedBox"
                                                                @change="handleCheckboxChangeluckydraw"></v-checkbox>
                                                        </div>
                                                        <div style="font-size: 14px;">
                                                            <div>
                                                                {{ $t('message.desLuckyTicket') }}
                                                            </div>
                                                            <div class="mt-3">
                                                                {{ $t('message.subDesLuckyTicketAdd') }} <span
                                                                    style="font-weight: bold; color: #FFFFFF;">{{
                                                                        $t('message.desLuckyTicketSpanBlod') }} </span> {{
                                                                        $t('message.subDesLuckyTicket') }} <a target="_blank"
                                                                    href="https://www.facebook.com/VirakBunthamExpress"
                                                                    style="text-decoration: underline; color: #FFFFFF;">{{
                                                                        $t('message.desLuckyTicketSpan') }}</a> {{
                                                                        $t('message.subDesLuckyTicket1') }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="">
                                                <div class="d-flexs" style="justify-content: space-between;"
                                                    v-if="disConut() != 0 || (returnTrip && disConutBack() != 0)">
                                                    <div class="static">
                                                        {{ $t('message.grandTotal') }}
                                                    </div>
                                                    <div class="dynamic" style="text-align: end;">
                                                        ${{ formatPrice(calculateGrandTotal()) }}
                                                    </div>
                                                </div>
                                                <div class="d-flexs mt-3" style="justify-content: space-between; "
                                                    v-if="returnTrip ? (((parseFloat(disConut()) || 0) + (parseFloat(disConutBack()) || 0)) !== 0) : ((parseFloat(disConut()) || 0) !== 0)">
                                                    <div class="d-flex static">
                                                        {{ $t('message.discount') }}
                                                        <div v-if="returnTrip">
                                                            ({{ getDiscountPercentage() }}%)
                                                        </div>
                                                        <div v-else style="padding-left: 2px;">
                                                            ({{ getDiscountPercentage() }}%)
                                                        </div>
                                                    </div>
                                                    <div class="dynamic"
                                                        style="text-align: end; justify-content: space-between;"
                                                        v-if="returnTrip">
                                                        <!-- ${{ formatPrice((parseFloat(disConut()) || 0) + (parseFloat(disConutBack()) || 0)) }} -->
                                                        ${{ formatPrice(totalDiscosunt()) }}
                                                    </div>
                                                    <div class="dynamic"
                                                        style="text-align: end; justify-content: space-between;" v-else>
                                                        ${{ formatPrice(disConut()) }}
                                                    </div>
                                                </div>
                                                <div class="d-flexs mt-3"
                                                    v-if="handleCheckboxChangeluckydraw() != 0 && calculateGrandTotal() > 0"
                                                    style="justify-content: space-between;">
                                                    <div class="static">
                                                        {{ $t('message.luckyTicket') }} :
                                                    </div>
                                                    <div class="dynamic" style="text-align: end;">
                                                        ${{ formatPrice(handleCheckboxChangeluckydraw()) }}

                                                    </div>

                                                </div>
                                                <div class="d-flexs mt-3" v-if="returnTrip"
                                                    style="justify-content: space-between;">
                                                    <div class="static">
                                                        {{ $t('message.total') }}
                                                    </div>
                                                    <div class="dynamic" style="text-align: end;">
                                                        ${{ formatPrice(parseFloat(priceDisTotalBack())) }}
                                                    </div>
                                                </div>
                                                <div class="d-flexs mt-3" v-else
                                                    style="justify-content: space-between;">
                                                    <div class="static">
                                                        {{ $t('message.total') }}
                                                    </div>
                                                    <div class="dynamic" style="text-align: end;" v-if="isCheckedBox">
                                                        ${{ formatPrice(priceDisTotalHaveLuckyDraw()) }}
                                                    </div>
                                                    <div class="dynamic" style="text-align: end;" v-else>
                                                        ${{ formatPrice(priceDisTotal()) }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row" style="margin-top: 0%;">
                        <div class="col-lg-7 col-md-7 col-sm-12">
                            <div style="">
                            </div>
                            <div class="check-box">
                                <!-- <label class="custom-checkbox-appy">
                                    <input type="checkbox" @change="handleCheckboxChange" v-model="ticktermandprivacy"
                                        style="transform: scale(1.5);">
                                    <span class="checkmark-appy"
                                        :class="{ 'checkbox-error': !ticktermandprivacy && (showAlert || showAlertfields) }"></span>
                                </label> -->
                                <div style="color: #424245;">
                                    {{ $t('message.desTermCoditionPrivacyPolicy') }} <a href="/term-condition"
                                        target="_blank" style="color: #312783;">{{
                                            $t('message.termCondition') }} </a> {{
                                            $t('message.desTermCoditionPrivacyPolicyAnd') }} <a href="/privacy-policy"
                                        target="_blank" style="color: #312783;">{{
                                            $t('message.privacyPolicy') }}</a></div>
                            </div>
                            <!-- v-if="processPayment" -->
                            <!-- Return Trip Button -->
                            <div class="proccess" v-if="returnTrip" @click="!loadingReturn && processPaymentTwo()"
                                :class="{ 'is-loading': loadingReturn }">
                                <div
                                    style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 15px;">
                                    <div>
                                        <div>{{ $t('message.processPayment') }}</div>
                                    </div>

                                    <div v-if="!loadingReturn">
                                        <i class="fas fa-arrow-right"></i>
                                    </div>
                                    <div v-else class="loader"></div>
                                </div>
                                <!-- <div style="display: flex; justify-content: space-between; padding: 12px; align-items: center; width: 100%;"  v-else>
                                    <div style="width: 100%;">

                                    </div>
                                    <div class="loader">

                                    </div>
                                </div> -->

                            </div>


                            <!-- One Way Trip Button -->
                            <div class="proccess" v-else @click="!loadingOneWay && processPayment()"
                                :class="{ 'is-loading': loadingOneWay }">
                                <div
                                    style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 15px;">
                                    <div>
                                        <div>{{ $t('message.processPayment') }}</div>
                                    </div>

                                    <div v-if="!loadingOneWay">
                                        <i class="fas fa-arrow-right"></i>
                                    </div>
                                    <div v-else class="loader"></div>

                                </div>
                                <!-- <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 12px;"  v-else>
                                    <div style="width: 100%;">

                                    </div>
                                    <div class="loader"></div>
                                </div> -->
                            </div>

                            <div>
                                <!-- required fields -->
                                <div class="alert-danger" v-if="showAlertfields && hasMissingFields">
                                    <img src="@/assets/seats/alert-danger.svg" alt="">
                                    <span style="padding-left: 1rem; color: #DC3545;"> {{
                                        $t('message.SomeOfTheRequiredFieldsAreMissing') }}</span>
                                </div>
                                <!-- termcondition and privacy policy -->
                                <div class="alert-danger" v-if="(showAlert || showAlertfields) && !ticktermandprivacy">
                                    <img src="@/assets/seats/alert-danger.svg" alt="">
                                    <span style="padding-left: 1rem; color: #DC3545;"> {{
                                        $t('message.PleaseAcceptTheTermOfUseAndPrivacyPolicyToContinue') }}</span>
                                </div>
                                <div class="alert-danger" v-if="emailinvalid">
                                    <img src="@/assets/seats/alert-danger.svg" alt="">
                                    <span style="padding-left: 1rem; color: #DC3545;"> {{
                                        $t('message.yourEmailInvalid') }}</span>
                                </div>
                                <div class="alert-danger" v-if="phoneNumberinvalid">
                                    <img src="@/assets/seats/alert-danger.svg" alt="">
                                    <span style="padding-left: 1rem; color: #DC3545;"> {{
                                        $t('message.yourTelephoneNumberInvalid') }}</span>
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-5 col-md-5 col-sm-12">

                        </div>
                    </div>
                </div>


            </div>
        </div>
        <!--View Trip Detail -->
        <div v-if="tripDetailsModalopen" class="trip-details-modal-overlay" style="background-color: #FFFFFF; box-shadow: #424245 0px 0px 10px;
             border-radius: 8px; z-index: 100; margin: 0;
             position: fixed; top: 100px; left: 50%; transform: translateX(-50%);
             width: 400px; max-height: 700px;">
            <div class="col-lg-12 col-md-12 col-sm-12" style="padding: 2rem;">
                <div class="fare-detail">
                    <span>{{ $t('message.Bookingsummary') }}</span>
                    <span @click="tripDetailsModalopen = false" style="cursor: pointer;"><i
                            class="fas fa-times"></i></span>
                </div>
                <div class="data-details" style="max-height: 550px; overflow-y: auto;">
                    <div style="line-height: 2;">
                        <div class="d-flexs">
                            <!-- <div class="static">
                                {{ $t('message.direction') }}
                            </div> -->
                            <div class="dynamic">
                                {{ getDestinationFrom() }} -
                                {{ getdestinationToName() }}
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ $t('message.vehicleType') }}
                            </div>
                            <div class="dynamic">
                                : {{ gettransportationType() }}
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ $t('message.departureDate') }}
                            </div>
                            <div class="dynamic">
                                : {{ getDateFrom() }}
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ $t('message.departureTime') }}
                            </div>
                            <div class="dynamic">
                                : {{ convertTimes(getDeparture()) }}
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ $t('message.arrivalTime') }}
                            </div>
                            <div class="dynamic">
                                : {{ convertTimes(getArrvalDate()) }}
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ getseatType() == 2 ? $t('message.selectedBed') : $t('message.selectedSeat') }}
                            </div>
                            <div class="dynamic">
                                : {{ getSeat() || 0 }}
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ getseatType() == 2 ? $t('message.bedno') : $t('message.seatno') }}
                            </div>
                            <div class="dynamic">
                                : {{ getSeatLabel() || '-' }}
                                <!-- ${{ formatPrice(TripPrice()) }} -->
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ $t('message.TicketPrice') }}
                            </div>
                            <div class="dynamic">
                                : ${{ formatPrice(TripPrice()) }}
                            </div>
                        </div>
                    </div>
                    <div v-if="returnTrip" style="line-height: 2;">
                        <div style="padding: 1rem 0rem 1rem 0rem;"><img style="width: 100%;" src="@/assets/Line112.png"
                                alt=""></div>
                        <div class="d-flexs">
                            <!-- <div class="static">
                                {{ $t('message.direction') }}
                            </div> -->
                            <div class="dynamic">
                                {{ getdestinationToName() }} -
                                {{ getDestinationFrom() }}
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ $t('message.vehicleType') }}
                            </div>
                            <div class="dynamic">
                                : {{ gettransportationTypeBack() }}
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ $t('message.departureDate') }}
                            </div>
                            <div class="dynamic">
                                : {{ getDateTo() }}
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ $t('message.departureTime') }}
                            </div>
                            <div class="dynamic">
                                : {{ convertTimes(getDepartureBack()) }}
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ $t('message.arrivalTime') }}
                            </div>
                            <div class="dynamic">
                                : {{ convertTimes(getArrvalDateBack()) }}
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ getseatTypeBack() == 2 ? $t('message.selectedBed') : $t('message.selectedSeat') }}
                            </div>
                            <div class="dynamic">
                                : {{ getSeatBack() || 0 }}
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ getseatTypeBack() == 2 ? $t('message.bedno') : $t('message.seatno') }}
                            </div>
                            <div class="dynamic">
                                : {{ getSeatLabelBack() || '-' }}
                                <!-- ${{ formatPrice(TripPriceBack()) }} -->
                            </div>
                        </div>
                        <div class="d-flexs">
                            <div class="static">
                                {{ $t('message.TicketPrice') }}
                            </div>
                            <div class="dynamic">
                                : ${{ formatPrice(TripPriceBack()) }}
                            </div>
                        </div>
                        <div class="d-flexs" v-if="!showpriceOriginalback">
                            <div class="static">
                                {{ $t('message.grandTotal') }}
                            </div>
                            <div class="dynamic">
                                : ${{ formatPrice(grandTotalBack()) }}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="data-details mt-2">
                    <div>
                        <div style="background: #F1AF88;" v-if="isLuckyDrawEnabled">
                            <div class="check-box" style="justify-content: center;">
                                <div class="text d-flex" style="color: #FFFFFF; font-size: 14px; width:92%;">
                                    {{ $t('message.luckyTicketTitle') }}
                                </div>
                            </div>
                            <div class="check-box" style="justify-content: center;">
                                <div class="text d-flex" style="color: #FFFFFF; width:92%; padding-bottom: 10px;">
                                    <div style="margin-top: -10px; margin-left: 2px">
                                        <v-checkbox color="#DE5D0A" style="transform: scale(1.5);"
                                            v-model="isCheckedBox" @change="handleCheckboxChangeluckydraw"></v-checkbox>
                                    </div>
                                    <div style="font-size: 14px;">
                                        <div>
                                            {{ $t('message.desLuckyTicket') }}
                                        </div>
                                        <div class="mt-3">
                                            {{ $t('message.subDesLuckyTicketAdd') }} <span
                                                style="font-weight: bold; color: #FFFFFF;">{{
                                                    $t('message.desLuckyTicketSpanBlod') }} </span> {{
                                                    $t('message.subDesLuckyTicket') }} <a target="_blank"
                                                href="https://www.facebook.com/VirakBunthamExpress"
                                                style="text-decoration: underline; color: #FFFFFF;">{{
                                                    $t('message.desLuckyTicketSpan') }}</a> {{
                                                    $t('message.subDesLuckyTicket1') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <div v-if="showCouponModal" class="promo-modal-overlay"
            style="position: fixed; inset: 0; background: rgba(0,0,0,0.45); display:flex; align-items:center; justify-content:center; z-index:2000;">
            <div class="promo-modal"
                style="width:444px; max-width:92%; background:#fff; border-radius:12px; padding:24px; position:relative;">
                <button @click="closeCouponModal" aria-label="Close"
                    style="position:absolute; right:16px; top:12px; border:0; background:transparent; font-size:20px; cursor:pointer;">×</button>
                <h3 style="margin:0 0 16px 0; font-size:20px; color:#20292F;">{{
                    $t('message.MyOffers') }}</h3>
                <div
                    style="display:flex; align-items:center; gap:12px; border: #D1D5DB solid 1px; border-radius: 25px; padding: 4px;">
                    <input type="text" v-model="safePromoInput" :placeholder="$t('message.EnterpromoCode')"
                        style="flex:1; padding:10px 16px; border:none; border-radius:20px; outline:none; font-size:16px; background:transparent;" />
                    <button :disabled="!promoInput || promoInput.trim() === '' || couponLoading"
                        @click="applyPromoFromModal" :style="{
                            border: '0',
                            background: (promoInput && promoInput.trim().length > 6) ? '#DE5D0A' : '#D9D9D9',
                            color: '#fff',
                            padding: '16px 45px',
                            borderRadius: '25px',
                            cursor: (promoInput && promoInput.trim().length > 6 && !couponLoading) ? 'pointer' : 'not-allowed',
                            fontWeight: 600
                        }">
                        <span v-if="couponLoading">{{ $t('message.Applying')
                            }}</span>
                        <span v-else>{{ $t('message.apply') }}</span>
                    </button>
                </div>
                <div style="display:flex; align-items:flex-start; gap:10px; margin-top:14px; color:#6B7280;">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                            stroke="#949494" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12 16V12" stroke="#949494" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M12 8H12.01" stroke="#949494" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>

                    <div style="font-size:14px; line-height:1.3;">{{
                        $t('message.Promotioncodevaluemustbeequaltoorhigherthantheticketprice')
                        }}
                    </div>
                </div>
                <div v-if="couponError"
                    style="display:flex; align-items:flex-start; gap:10px; margin-top:14px; color:#6B7280;">
                    <i class="fa-solid fa-triangle-exclamation" style="color: #DC3545; padding-top: 3px;"></i>
                    <div style="font-size:14px; line-height:1.3; color: #DC3545;">
                        {{ couponError }}
                    </div>
                </div>
            </div>
        </div>

        <div v-if="tripDetailsModalopen" class="modal-background" @click="tripDetailsModalopen = false" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
             background: rgba(0, 0, 0, 0.5); z-index: 99;">
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';

export default {
    name: 'PassengerPage',
    props: {
        tabindex: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    data() {
        return {
            validateField: false,
            fullname: [], // Initialize as empty array instead of single item
            fullnameback: [],
            email: localStorage.getItem('emailProfile'),

            index: 0,
            selectedOption: 'message.gender',
            selectedOption1: this.$t("message.male"),
            selectedOption2: this.$t("message.Female"),
            selecteGenBack0: 'message.gender',
            selectedOptionBack1: this.$t("message.male"),
            selectedOptionBack2: this.$t("message.Female"),
            phone: '',
            phoneNumberError: [],
            maxLength: 9, // maximum allowed phone number length
            maxLengths: 10, // maximum allowed phone number length
            msg: [],
            isValidEmail: true,
            isLoggedIn: !!localStorage.getItem('session_start_login'),
            seatNum: [],
            seatNumBack: [],
            seatLabelBack: '',
            total: 0,
            returnTrip: false,
            checkbox: false,
            seatLabels: [],
            seatLabelbacks: [],
            checkNational: true,
            radioGroup: 1,

            packageCode: "",
            promoCode: "",
            couponCode: "",
            promoInput: "",
            promoError: "",
            couponError: "",
            couponResponse: null,
            couponLoading: false,
            isCouponApplied: false,
            isCheckCouponApply: false,
            showCouponModal: false,
            showpriceOriginalback: false,
            priceOriginal: false,
            discount: 5,
            discountpackage: "",
            selected: [],      // Outbound gender array
            selectedback: [],  // Return trip gender array
            selectedname: [],
            activeItem: 0,
            showListDataGen: false,
            showListDataGenBack: false,
            check: false,
            isCheckedBox: false,
            isCheckPackageApply: false,
            isUseLuckyDraw: '',
            dropOffBack: [], // Add this line
            boardingPoint: [],
            dropOffPoint: [],
            boardingPointBack: [],
            dropOffPointBack: [],
            selectedBoxId: "",
            selectedBox: "",
            selectedBoxname: "",
            lats: "",
            longs: "",
            latsdropoff: "",
            longsdropoff: "",
            latspointBack: "",
            longsPointBack: "",
            latspointBackoff: "",
            longsPointBackoff: "",
            selectedBoxIdBack: "",
            selectedBoxBack: "",
            selectedBoxIdBackDown: "",
            selectedBoxBackDown: "",
            selectedBoxBackDownname: "",
            selectedBoxIdBackoffDown: "",
            selectedBoxBackoffDown: "",
            selectedBoxBackoffDownname: "",

            selectedBoxDownId: "",
            selectedBoxDown: "",
            selectedBoxDownname: "",
            selectedCheckbox: null,
            selectedCheckboxDown: null,
            selectedCheckboxBack: null,
            selectedCheckboxBackDown: null,

            pointName: "",
            pointId: "",
            pointNameDown: "",
            pointIdDown: "",
            pointNameBack: "",
            pointIdBack: "",
            pointNameBackDown: "",
            pointIdBackDown: "",

            disPercent: localStorage.getItem('disPercent'),
            packagedis: '',
            disPercentBack: localStorage.getItem('disPercentBack'),

            open: false,
            open1: false,
            open2: false,
            open3: false,
            isPackageApplied: false, // New property to manage checkbox state
            is_booking: false,
            is_register: false,
            showNationalityDropdown: false,
            nationalitySelected: [], // Add this line
            nationalitySelectedBack: [], // Add this line
            activeNationalityItem: null, // Track which dropdown is active
            showNationalityDropdownBack: false,
            activeNationalityItemBack: null,
            listnation: [],
            nationalityid: [],
            showListDataNation: false,
            filteredNations: [],
            nationality: [], // Change to array to store nationality for each passenger
            nationalityBack: [], // For return trip
            nationalityidBack: [], // For return trip
            lang: localStorage.getItem('lang'),
            tripDetailsModalopen: false,
            ticktermandprivacy: true,
            showAlert: false,
            showAlertfields: false,
            loadingReturn: false,
            loadingOneWay: false,
            loadingBoardingPoints: false,
            phoneNumberinvalid: false,
            emailinvalid: false,
            loadingDropOffPoints: false,
            dropOffPointCache: new Map(), // Cache for drop-off points
        }
    },
    watch: {
        tripDetailsModalopen(newVal) {
            if (newVal) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        },
        email(value) {
            // binding this to the data value in the email input
            this.email = value;
            this.validateEmailRealTime();
        },
        phone(value) {
            this.phone = value;
            this.validatePhoneNumber(value);
        },
        returnTrip: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    // Re-initialize nationality arrays when return trip is enabled
                    this.initializeNationality();
                }
            }
        }
    },
    computed: {
        isLuckyDrawEnabled() {
            const cutoffDate = new Date('2024-12-31');
            const journeyDate = new Date(localStorage.getItem('dateFrom'));
            const journeyDateBack = localStorage.getItem('dateTo') ? new Date(localStorage.getItem('dateTo')) : null;

            // Check if either journey date is after cutoff
            if (journeyDate > cutoffDate) return false;
            if (journeyDateBack && journeyDateBack > cutoffDate) return false;

            return true;
        }
        ,
        /**
         * true when any required field is missing. This is checked only when
         * validation is triggered (we use `showAlertfields` in the template to
         * avoid showing errors before the user attempts to submit).
         */
        hasMissingFields() {
            try {
                // Outbound passengers
                if (this.seatLabels && this.seatLabels.length) {
                    for (let i = 0; i < this.seatLabels.length; i++) {
                        const name = (this.fullname && this.fullname[i]) ? String(this.fullname[i]).trim() : '';
                        if (!name) return true;
                        const gender = (this.selected && typeof this.selected[i] !== 'undefined') ? this.selected[i] : 0;
                        if (!gender) return true;
                        const nat = (this.nationality && this.nationality[i]) ? String(this.nationality[i]).trim() : '';
                        if (!nat) return true;
                    }
                }

                // Return trip passengers
                if (this.returnTrip && this.seatLabelbacks && this.seatLabelbacks.length) {
                    for (let i = 0; i < this.seatLabelbacks.length; i++) {
                        const name = (this.fullnameback && this.fullnameback[i]) ? String(this.fullnameback[i]).trim() : '';
                        if (!name) return true;
                        const gender = (this.selectedback && typeof this.selectedback[i] !== 'undefined') ? this.selectedback[i] : 0;
                        if (!gender) return true;
                        const nat = (this.nationalityBack && this.nationalityBack[i]) ? String(this.nationalityBack[i]).trim() : '';
                        if (!nat) return true;
                    }
                }

                // Boarding/dropoff selections when multiple options exist
                if (this.boardingPoint && this.boardingPoint.length !== 1) {
                    if (!this.selectedBoxname || String(this.selectedBoxname).trim() === '') return true;
                }
                if (this.dropOffPoint && this.dropOffPoint.length !== 1) {
                    if (!this.selectedBoxDownname || String(this.selectedBoxDownname).trim() === '') return true;
                }
                if (this.returnTrip) {
                    if (this.boardingPointBack && this.boardingPointBack.length !== 1) {
                        if (!this.selectedBoxBackDownname || String(this.selectedBoxBackDownname).trim() === '') return true;
                    }
                    if (this.dropOffPointBack && this.dropOffPointBack.length !== 1) {
                        if (!this.selectedBoxBackoffDownname || String(this.selectedBoxBackoffDownname).trim() === '') return true;
                    }
                }

                // Contact
                const emailFilled = this.email && String(this.email).trim() !== '';
                const phoneFilled = this.phone && String(this.phone).trim() !== '';
                const session = localStorage.getItem('session_start_login');
                if (session) {
                    // When user is logged in, require at least one of email or phone
                    if (!emailFilled && !phoneFilled) return true;
                } else {
                    // When not logged in, require only the primary contact field
                    if (!emailFilled) return true;
                }

                return false;
            } catch (e) {
                return true;
            }
        },
        contactPlaceholder() {
            const emailLabel = this.$t('message.emailAddress');
            if (!this.isLoggedIn) {
                // const phoneLabel = this.$t('message.enterTelephoneNumber');
                return `${emailLabel}`;
            }
            return emailLabel;
        },
        shouldHighlightEmailField() {
            if (!this.showAlertfields) return false;
            const emailTrimmed = (this.email || '').trim();
            const phoneTrimmed = (this.phone || '').trim();
            if (this.isLoggedIn) {
                return !emailTrimmed && !phoneTrimmed;
            }
            return !emailTrimmed;
        },
        shouldHighlightPhoneField() {
            if (!this.showAlertfields) return false;
            const phoneTrimmed = (this.phone || '').trim();
            const luckyDrawRequiresPhone = Number(this.isUseLuckyDraw) === 1;
            if (luckyDrawRequiresPhone && !phoneTrimmed) {
                return true;
            }
            if (!this.isLoggedIn) return false;
            const emailTrimmed = (this.email || '').trim();
            return !emailTrimmed && !phoneTrimmed;
        },
        safePromoInput: {
            get() {
                return this.normalizePromoValue(this.promoInput);
            },
            set(value) {
                this.promoInput = this.normalizePromoValue(value);
            }
        }
    },

    methods: {
        getseatType() {
            const seatType = localStorage.getItem('seatType');
            return seatType ? seatType : '';
        },
        getseatTypeBack() {
            const seatTypeBack = localStorage.getItem('seatTypeBack');
            return seatTypeBack ? seatTypeBack : '';
        },
        showTripDetailsModal() {
            this.tripDetailsModalopen = true;
        },
        hideTripDetailsModal() {
            this.tripDetailsModalopen = false;
        },
        handleCheckboxChange() {
            if (this.ticktermandprivacy) {
                this.showAlert = false;
            }
        },
        normalizePromoValue(value) {
            if (value == null) return '';
            const normalized = String(value).trim();
            const lower = normalized.toLowerCase();
            if (!normalized || lower === 'undefined' || lower === 'null') {
                return '';
            }
            return normalized;
        },
        hidePopupNation() {
            this.showListDataNation = false;
            this.activeNationalityItem = null;
            this.activeNationalityItemBack = null;
        },

        onClickOutside(event) {
            // Check if the click was outside the dropdown
            const dropdowns = document.querySelectorAll('.nationality-dropdown');
            let clickedInside = false;

            dropdowns.forEach(dropdown => {
                if (dropdown.contains(event.target)) {
                    clickedInside = true;
                }
            });

            if (!clickedInside) {
                this.hidePopupNation();
            }
        },

        setNational(index, id, name, isReturn = false) {
            if (isReturn) {
                // For return trip
                this.$set(this.nationalityBack, index, name);
                this.$set(this.nationalityidBack, index, id);
                localStorage.setItem('nationalitynamelistback', this.nationalityBack);
            } else {
                // For outbound trip
                this.$set(this.nationality, index, name);
                this.$set(this.nationalityid, index, id);
                localStorage.setItem('nationalitynamelist', this.nationality);
                // Automatically copy to return trip if it exists
                if (this.returnTrip) {
                    this.$set(this.nationalityBack, index, name);
                    this.$set(this.nationalityidBack, index, id);
                    localStorage.setItem('nationalitynamelistback', this.nationalityBack);
                }
            }
            this.hidePopupNation();
        },
        async selectNation(index, isReturn = false) {
            // Toggle dropdown for clicked index
            const activeIndex = isReturn ? this.activeNationalityItemBack : this.activeNationalityItem;

            if (activeIndex === index) {
                this.hidePopupNation();
            } else {
                // Reset filtered nations to show all options when switching to a different passenger
                this.filteredNations = [...this.listnation];

                // Set the appropriate active item based on trip direction
                if (isReturn) {
                    this.activeNationalityItemBack = index;
                    this.activeNationalityItem = null; // Close outbound dropdown
                } else {
                    this.activeNationalityItem = index;
                    this.activeNationalityItemBack = null; // Close return dropdown
                }

                this.showListDataNation = true;

                // Initialize filtered nations if needed
                if (!this.filteredNations.length) {
                    this.filteredNations = [...this.listnation];
                }
            }
        },
        async getNationality() {
            try {
                const response = await axios({
                    method: "POST",
                    headers: this.$header,
                    url: this.$url + 'travel-package/nationalityList'
                });

                if (response.status === 200 &&
                    response.data.header.result &&
                    response.data.header.statusCode === 200) {

                    this.listnation = response.data.body.data;
                    this.filteredNations = [...this.listnation];

                    // After getting nations, initialize stored values if any
                    const storedId = localStorage.getItem('nationalityId');
                    const storedName = localStorage.getItem('nationalityIdProfile');

                    if (storedName) {
                        this.$set(this.nationality, 0, storedName);

                        if (this.returnTrip) {
                            this.$set(this.nationalityBack, 0, storedName);
                        }
                    }
                    if (storedId) {
                        this.$set(this.nationalityid, 0, storedId);

                        if (this.returnTrip) {
                            this.$set(this.nationalityidBack, 0, storedId);
                        }
                    }

                    this.syncNationalityIdsFromNames(false);
                    this.syncNationalityIdsFromNames(true);
                }
            } catch (error) {
                console.error('Error fetching nationalities:', error);
            }
        },
        storeData(pointName, pointId) {
            this.pointName = pointName;
            this.pointId = pointId;
            if (pointId == '') {
                this.selectedCheckbox = null;
            } else if (this.selectedCheckbox == pointId) {
                this.selectedCheckbox = pointId;
            } else {
                this.selectedCheckbox = pointId;
            }
            localStorage.setItem("boardingpointAddress", this.pointName);
            localStorage.setItem('boardingPointId', this.pointId);
        },
        storeDataDown(pointNameDown, pointIdDown) {
            this.pointNameDown = pointNameDown;
            this.pointIdDown = pointIdDown;
            if (pointIdDown == '') {
                this.selectedCheckboxDown = null;
            } else if (this.selectedCheckboxDown == pointIdDown) {
                this.selectedCheckboxDown = pointIdDown;
            } else {
                this.selectedCheckboxDown = pointIdDown;
            }
            localStorage.setItem("dropOffPointName", this.pointNameDown);
            localStorage.setItem('dropOffPointId', this.pointIdDown);
        },
        storeDataBack(pointNameBack, pointIdBack) {
            this.pointNameBack = pointNameBack;
            this.pointIdBack = pointIdBack;
            if (pointIdBack == '') {
                this.selectedCheckboxBack = null;
            } else if (this.selectedCheckboxBack == pointIdBack) {
                this.selectedCheckboxBack = pointIdBack;
            } else {
                this.selectedCheckboxBack = pointIdBack;
            }
            localStorage.setItem("boardingPointNameBack", this.pointNameBack);
            localStorage.setItem('boardingPointIdBack', this.pointIdBack);
        },
        storeDataBackDown(pointNameBackDown, pointIdBackDown) {
            this.pointNameBackDown = pointNameBackDown;
            this.pointIdBackDown = pointIdBackDown;
            if (pointIdBackDown == '') {
                this.selectedCheckboxBackDown = null;
            } else if (this.selectedCheckboxBackDown == pointIdBackDown) {
                this.selectedCheckboxBackDown = pointIdBackDown;
            } else {
                this.selectedCheckboxBackDown = pointIdBackDown;
            }
            localStorage.setItem("dropOffPointNameBack", this.pointNameBackDown);
            localStorage.setItem('dropOffPointIdBack', this.pointIdBackDown);
        },

        navigateToMap(lats, longs) {
            const url = `https://maps.google.com/maps?q=${lats},${longs}`;
            window.open(url, '_blank');
        },
        autoFieldToBack(index) {
            if (this.returnTrip) {
                // Only copy name if valid
                if (index < this.fullnameback.length) {
                    this.fullnameback[index] = this.fullname[index];
                }
                // Only copy nationality if return trip nationality hasn't been manually set
                if (!this.nationalityBack[index] && this.nationality[index]) {
                    this.nationalityBack[index] = this.nationality[index];
                    this.nationalityidBack[index] = this.nationalityid[index];
                }
                // Only copy gender if return trip gender hasn't been manually set
                if (!this.selectedback[index] && this.selected[index]) {
                    this.selectedback[index] = this.selected[index];
                    // Update display text based on gender
                    if (this.selected[index] === 1) {
                        this.selectedOptionBack1 = this.$t("message.male");
                    } else if (this.selected[index] === 2) {
                        this.selectedOptionBack2 = this.$t("message.Female");
                    }
                }
            }
        },

        myChangeFunction(index) {
            if (this.returnTrip) {
                // Only copy name if valid
                if (index < this.fullnameback.length) {
                    this.fullnameback[index] = this.fullname[index];
                }
                // Only copy nationality if return trip nationality hasn't been manually set
                if (!this.nationalityBack[index] && this.nationality[index]) {
                    this.nationalityBack[index] = this.nationality[index];
                    this.nationalityidBack[index] = this.nationalityid[index];
                }
                // Only copy gender if return trip gender hasn't been manually set
                if (!this.selectedback[index] && this.selected[index]) {
                    this.selectedback[index] = this.selected[index];
                    // Update display text based on gender
                    if (this.selected[index] === 1) {
                        this.selectedOptionBack1 = this.$t("message.male");
                    } else if (this.selected[index] === 2) {
                        this.selectedOptionBack2 = this.$t("message.Female");
                    }
                }
            }
        },
        // Check roundTirp
        getCheck() {
            if (localStorage.getItem('dateTo') != null) {
                this.returnTrip = true;
            } else {
                this.returnTrip = false;
            }
        },
        // Start Get Data
        getDestinationFrom() {
            if (localStorage.getItem('lang') == 'ch') {
                return localStorage.getItem('departureFromNameCn');
            } else if (localStorage.getItem('lang') == 'kh') {
                return localStorage.getItem('departureFromNameKh');
            } else {
                return localStorage.getItem('departureFromName');
            }
        },
        getdestinationToName() {
            if (localStorage.getItem('lang') == 'ch') {
                return localStorage.getItem('destinationToNameCn');
            } else if (localStorage.getItem('lang') == 'kh') {
                return localStorage.getItem('destinationToNameKh');
            } else {
                return localStorage.getItem('destinationToName');
            }
        },
        getDateFrom() { return localStorage.getItem('dateFrom'); },
        getDateTo() { return localStorage.getItem('dateTo'); },
        getDeparture() { return localStorage.getItem('departure'); },
        getDepartureBack() { return localStorage.getItem('departureback'); },
        getArrvalDate() { return localStorage.getItem('arrival'); },
        getArrvalDateBack() { return localStorage.getItem('arrivalback'); },
        convertTimes(time) {
            if (!time || typeof time !== 'string' || !time.includes(':')) {
                return time || '-';
            }
            const [hours, minutes] = time.split(':');
            return `${hours}:${minutes}`;
        },
        getSeat() {
            const seatStr = localStorage.getItem('seat');
            if (seatStr && seatStr !== '') {
                const seatNumArray = seatStr.split(",").filter(s => s); // Remove empty strings
                this.seatNum = seatNumArray.length;
                return this.seatNum;
            }
            return 0;
        },
        getSeatLabel() {
            const seatLabelStr = localStorage.getItem('seatlabel');
            if (seatLabelStr && seatLabelStr !== '') {
                const seatArray = seatLabelStr.split(",").filter(s => s); // Remove empty strings
                return seatArray.join(", ");
            }
            return '';
        },
        getSeatBack() {
            const seatBackStr = localStorage.getItem('seatback');
            if (seatBackStr && seatBackStr !== '') {
                const seatNumBackArray = seatBackStr.split(",").filter(s => s); // Remove empty strings
                this.seatNumBack = seatNumBackArray.length;
                return this.seatNumBack;
            }
            return 0;
        },
        getSeatLabelBack() {
            const seatLabelBackStr = localStorage.getItem('seatlabelback');
            if (seatLabelBackStr && seatLabelBackStr !== '') {
                const seatArray = seatLabelBackStr.split(",").filter(s => s); // Remove empty strings
                this.seatLabelBack = seatArray.join(", ");
                return this.seatLabelBack;
            }
            return '';
        },
        getSafePriceValue(value) {
            const parsed = parseFloat(value);
            return Number.isFinite(parsed) ? parsed : 0;
        },
        getOutboundPackageBasePrice() {
            const priceOriginalRaw = localStorage.getItem('priceOriginal');
            const resultTotalRaw = localStorage.getItem('resultTotal');
            const priceOriginal = this.getSafePriceValue(priceOriginalRaw);
            const resultTotal = this.getSafePriceValue(resultTotalRaw);

            const useOriginal = priceOriginal > 0;
            const selected = useOriginal ? priceOriginal : resultTotal;
            return selected;
        },
        getReturnPackageBasePrice() {
            const priceOriginalBackRaw = localStorage.getItem('priceOriginalback');
            const resultTotalBackRaw = localStorage.getItem('resultTotalBack');
            const priceOriginalBack = this.getSafePriceValue(priceOriginalBackRaw);
            const resultTotalBack = this.getSafePriceValue(resultTotalBackRaw);

            const useOriginalBack = priceOriginalBack > 0;
            const selected = useOriginalBack ? priceOriginalBack : resultTotalBack;
            return selected;
        },
        // Start One way 
        // Grand Total both Period and auto discount(5%)
        grandTotal() {
            // if 
            // (this.isCheckPackageApply) {
            //     return this.getOutboundPackageBasePrice();
            // } else
            //  {
                if (localStorage.getItem('priceOriginal') == "" || localStorage.getItem('priceOriginal') == null) {
                    this.priceOriginal = false;
                } else {
                    this.priceOriginal = true;
                }
                return localStorage.getItem('resultTotal');
            // }
        },
        // Total both Period and auto discount(5%)
        priceDisTotal() {
            if (this.isCheckPackageApply) {
                const totalAmount = localStorage.getItem('resultTotal') - parseFloat(this.disConut());
                return parseFloat(totalAmount.toFixed(2));
            } else {
                const totalAmount = parseFloat(localStorage.getItem('resultTotal')) - this.disConut();
                return parseFloat(totalAmount.toFixed(2));
            }
        },
        priceDisTotalHaveLuckyDraw() {
            return localStorage.getItem('resultTotal') - this.disConut() + parseFloat(this.handleCheckboxChangeluckydraw());
        },
        disConut() {
            // If package discount is applied, use package discount rate
            if (this.isCheckPackageApply && this.packagedis) {
                const totalAmount = localStorage.getItem('resultTotal');
                const discountPercentage = this.packagedis;
                const rawDiscount = parseFloat(this.roundDiscount((totalAmount * discountPercentage/100))).toFixed(2);
                return rawDiscount;
            }
            if (this.isCouponApplied) {
                return localStorage.getItem('resultTotal');
            }

            // Check if originalPrice exists - if so, no regular discount applies
            const hasOriginalPrice = localStorage.getItem('priceOriginal') !== "" &&
                localStorage.getItem('priceOriginal') !== null;
            if (hasOriginalPrice) {
                return "0.00";
            }

            const calTotal = parseFloat(localStorage.getItem('calTotal')) || 0;
            const seatPrice = parseFloat(localStorage.getItem('price')) || 0;
            // Round per-seat discount to 2 decimals (e.g., 0.325 => 0.33)
            const discountPercentage = Math.round(((seatPrice * 5) / 100));
            let rawDiscount = calTotal * discountPercentage;
            return this.roundDiscount(rawDiscount);
        },
        // disConutForDisplay() {

        //     // If package discount is applied, use package discount rate
        //     if (this.isCheckPackageApply && this.packagedis) {
        //         const totalAmount = parseFloat(localStorage.getItem('priceOriginal'));
        //         const discountPercentage = this.packagedis || 5; // Default to 5% if packagedis is falsy
        //         // const discountPercentage = this.packagedis;
        //         const rawDiscount = ((totalAmount * (discountPercentage / 100)) * 100) / 100;
        //         return this.roundDiscount(rawDiscount);
        //     }

        //     // Check if originalPrice exists - if so, no regular discount applies
        //     const hasOriginalPrice = localStorage.getItem('priceOriginal') !== "" &&
        //         localStorage.getItem('priceOriginal') !== null;
        //     if (hasOriginalPrice) {
        //         return "0.00";
        //     }
        //     return this.roundDiscount(0.00);
        // },

        // End One way 

        // Start Two way 

        // Grand Total both Period and auto discount(5%)
        grandTotalBack() {
            // if (this.isCheckPackageApply) {
            //     if (this.returnTrip) {
            //         return this.getReturnPackageBasePrice();
            //     }
            // } else {
                if (localStorage.getItem("priceOriginalback") == "" || localStorage.getItem("priceOriginalback") == null) {
                    this.showpriceOriginalback = false;
                } else {
                    this.showpriceOriginalback = true;
                }
                return localStorage.getItem('resultTotalBack');
            // }
        },
        TripPrice() {
            // if (this.isCheckPackageApply) {
            //     const total = this.getOutboundPackageBasePrice();
            //     console.log('[TravelPackage][TripPrice-outbound]', {
            //         total,
            //         packagedis: this.packagedis,
            //         isPackageApplied: this.isPackageApplied
            //     });
            //     return total;
            // }
            return localStorage.getItem('resultTotal');
        },
        TripPriceBack() {
            // if (this.isCheckPackageApply) {
            //     const total = this.getReturnPackageBasePrice();
            //     console.log('[TravelPackage][TripPrice-return]', {
            //         total,
            //         packagedis: this.packagedis,
            //         isPackageApplied: this.isPackageApplied
            //     });
            //     return total;
            // }
            return localStorage.getItem('resultTotalBack');
        },

        // Total both Period and auto discount(5%)
        priceDisTotalBack() {
                const totalAmount = parseFloat(localStorage.getItem('resultTotal')) +
                    parseFloat(localStorage.getItem('resultTotalBack'));
                const totalDiscount = this.totalDiscosunt();
                return  parseFloat(totalAmount - totalDiscount).toFixed(2);
        },

        grandTotalBackSubDis() {
            if (localStorage.getItem("priceOriginalback") == "" || localStorage.getItem("priceOriginalback") == null) {
                return localStorage.getItem('resultTotalBack') - this.disConutBack();
            } else {
                return localStorage.getItem('resultTotalBack');
            }
        },

        disConutBack() {
            // If package discount is applied, use package discount rate
            if (this.isCheckPackageApply) {
                const totalAmount = localStorage.getItem('resultTotalBack')
                const discountPercentage = this.packagedis;
                const rawDiscount = parseFloat((totalAmount * discountPercentage)/ 100).toFixed(2);
                return this.roundDiscount(rawDiscount);
            }

            // Check if originalPrice exists for return trip - if so, no regular discount applies
            const hasOriginalPriceBack = localStorage.getItem('priceOriginalback') !== "" &&
                localStorage.getItem('priceOriginalback') !== null;
            if (hasOriginalPriceBack) {
                return "0.00";
            }

            const calTotal = parseFloat(localStorage.getItem('calTotalback')) || 0;
            const seatPrice = parseFloat(localStorage.getItem('seatPriceback')) || 0;
            // Round per-seat discount to 2 decimals (e.g., 0.325 => 0.33)
            const discountPercentage = Math.round(((seatPrice * 5) / 100) * 100) / 100;
            let rawDiscount = calTotal * discountPercentage;
            return this.roundDiscount(rawDiscount);
        },
        totalDiscosunt() {
            // If package discount is applied, calculate total package discount
            if (this.isCheckPackageApply) {
                const totalAmount = this.calculateGrandTotal();
                const totalAmountFloat = parseFloat(this.roundDiscount(totalAmount)).toFixed(2);
                const discountPercentage = parseFloat(this.packagedis);
                const rawDiscount = parseFloat(this.roundDiscount((totalAmountFloat * discountPercentage)/100)).toFixed(2);
                return rawDiscount;
            }

            // For regular discount, sum both trip discounts (if applicable)
            const firstTripDiscount = parseFloat(this.disConut());
            const returnTripDiscount = parseFloat(this.disConutBack());
            const totalDiscount = firstTripDiscount + returnTripDiscount;
            return this.roundDiscount(totalDiscount);
        },

        totalReture() {
            let totals = parseFloat(localStorage.getItem('resultTotal')) + parseFloat(localStorage.getItem('resultTotalBack'));
            return this.total = totals;
        },
        // End Two way 

        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace('.', '.');
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },

        /* ------- Start One Way -----*/
        getSeatLabelRetureBack() {
            // Handle outbound seats
            const seatLabels = localStorage.getItem('seatlabel')?.split(',').filter(s => s) || [];
            this.seatLabels = seatLabels;
            this.selected = new Array(seatLabels.length).fill(0);

            // Handle return trip seats if they exist
            if (localStorage.getItem('seatlabelback')) {
                const seatLabelsBack = localStorage.getItem('seatlabelback').split(',').filter(s => s);
                this.seatLabelbacks = seatLabelsBack;
                this.selectedback = new Array(seatLabelsBack.length).fill(0);
            }

            // Initialize first passenger's gender from profile if available
            const profileGender = localStorage.getItem('genderProfile');
            if (profileGender) {
                const genderValue = parseInt(profileGender);
                if (this.selected.length > 0) {
                    this.selected[0] = genderValue;
                    this.setGender(0, genderValue); // This will handle display text updates
                }
                if (this.returnTrip && this.selectedback.length > 0) {
                    this.selectedback[0] = genderValue;
                    this.setGenderBack(0, genderValue); // This will handle display text updates
                }
            }
        },
        calculateGrandTotal() {
            if (this.grandTotalBack() == null || this.grandTotalBack() == "") {
                return (parseFloat(this.grandTotal()));

            } else {
                return (parseFloat(this.grandTotal()) + parseFloat(this.grandTotalBack()));
            }
        },
        showPopupGen() {
            this.showListDataGen = true;
            this.showListDataGenBack = true;
        },
        hidePopupGen() {
            this.showListDataGen = false;
            this.showListDataGenBack = false;
        },
        /*--------- Get Travel Package Code  -------*/
        async getTravelPackageCode() {
            const url = this.$url + `travel-package/packageBuyList`;
            const session = localStorage.getItem('session_start_login');
            if (!session) {
                alert('hello');
                this.isCheckPackageApply = false;
                this.isPackageApplied = false;
                return
            }

            const data = {
                'session': session,
            }
            let config = {
                method: "POST",
                headers: {
                    ...this.$header,
                    "Content-Type": "multipart/form-data"
                },
                data: data,
                url,
            };

            try {
                const response = await axios(config);
                if (response.data.header.result && response.data.header.statusCode === 200) {
                    if (response.data.body.length != 0) {
                        // Clear old packageCode
                        localStorage.removeItem('packageCode');
                        const vehicleType = localStorage.getItem('vehicleType');
                        const lastIndex = response.data.body.reverse();

                        if (this.returnTrip) {
                            const vehicleTypeBack = localStorage.getItem('vehicleTypeBack');
                            if (lastIndex[0].type == 2 && (vehicleType == 2 || vehicleTypeBack == 2)) {
                                this.packageCode = null;
                                this.isCheckPackageApply = false;
                                alert("First-class seats are not available for travel packages with a student grade A");
                                throw new Error("First-class seats are not available for travel packages with a student grade A");
                            } else {
                                this.packageCode = lastIndex[0].packageCode;
                                localStorage.setItem('packageCode', this.packageCode);
                            }
                        } else {
                            if (vehicleType == 2 && lastIndex[0].type == 2) {
                                this.packageCode = null;
                                this.isCheckPackageApply = false;
                                // localStorage.removeItem('packageCode');
                                alert("First-class seats are not available for travel packages with a student grade A");
                                throw new Error("First-class seats are not available for travel packages with a student grade A");
                            } else {
                                this.packageCode = lastIndex[0].packageCode;
                                localStorage.setItem('packageCode', this.packageCode);
                            }
                        }
                    } else {
                        alert("Cannot apply travel package")
                        this.packageCode = null;
                        this.isCheckPackageApply = false;
                    }
                } else {
                    alert("Cannot apply travel package")
                    this.packageCode = null;
                    this.isCheckPackageApply = false;
                    throw new Error("Cannot apply travel package");
                }

            }
            catch (error) {
                console.error('[TravelPackage][getTravelPackageCode:error]', error);
                this.isCheckPackageApply = false;
                this.packageCode = null;
                if (this.vehicleType === 2) {
                    alert("Cannot apply travel package")
                    return;
                }

            }
        },

        checkPackageApply() {
            const session = localStorage.getItem('session_start_login');
            if (!session) {
                this.isPackageApplied = false;  // Reset package status
                return;
            }
            const journeyId = localStorage.getItem('journeyid');
            const travelDate = localStorage.getItem('dateFrom');
            const code = localStorage.getItem('packageCode');

            if (!session || !journeyId || !travelDate || !code) {
                this.isPackageApplied = false
            }

            const data = new FormData();
            data.append('session', session);
            data.append('code', code);
            data.append('journeyId', journeyId);
            data.append('travelDate', travelDate);

            const url = this.$url + `booking/checkPackageApply`;

            let config = {
                method: "POST",
                headers: {
                    ...this.$header,
                    "Content-Type": "multipart/form-data"
                },
                data: data,
                url,
            };
            // Add better error handling and logging
            axios(config)
                .then((response) => {
                    if (response.status == 200) {
                        if (response.data.header.result == true && response.data.header.statusCode == 200) {

                            if (response.data.body.status == 1) {
                                this.isPackageApplied = true;
                                const discountPercentage = response.data.body.discount;
                                this.packagedis = discountPercentage;
                                // Calculate discount
                                const discountValue = parseFloat(discountPercentage) / 100;
                                const totalAmount = this.calculateGrandTotal();
                                const discountAmount = parseFloat(this.roundDiscount(totalAmount * discountValue));
                                const newTotal = totalAmount - discountAmount;

                                this.discountpackage = discountAmount;
                                localStorage.setItem('totalAmount', newTotal);
                            } else if (response.data.body.status == 2) {
                                this.isCheckPackageApply = false;
                                this.isPackageApplied = false;
                                alert(this.$t('message.Traveldateoverpackageexpirydate'));

                            } else if (response.data.body.status == 3) {
                                this.isCheckPackageApply = false;
                                this.isPackageApplied = false; // Fixed assignment operator
                                alert(this.$t('message.Thebookingdatehasbeenbooked'))
                            } else {
                                this.isCheckPackageApply = false;
                                this.isPackageApplied = false; // Fixed assignment operator
                                alert(this.$t('message.Thebookingdatehasbeenbooked'))
                            }
                        }
                        else {
                            console.warn('[TravelPackage][checkPackageApply:invalid-package]', response.data);
                            this.isCheckPackageApply = false
                            alert('Invalid travel package code');
                        }
                    }
                })
                .catch((error) => {
                    console.error('Error in checkPackageApply:', error);
                    this.isCheckPackageApply = false;
                    this.isPackageApplied = false;
                    alert('Error checking travel package. Please try again.');
                });
        },

        /*--------- Optimized Loading Methods -------*/
        async loadBoardingAndDropOffPoints() {
            const journeyId = localStorage.getItem('journeyid');
            const journeyIdBack = localStorage.getItem('journeyidback');

            if (!journeyId) {
                console.error('No journey ID found');
                return;
            }

            // Set loading states
            this.loadingBoardingPoints = true;
            this.loadingDropOffPoints = true;

            try {
                // Load outbound trip data in parallel
                const outboundPromises = [
                    this.getBoardingPoint(journeyId),
                    this.getDropOffPoint(journeyId)
                ];

                // If return trip exists, load return trip data in parallel
                if (journeyIdBack) {
                    const returnPromises = [
                        this.getBoardingPointBack(journeyIdBack),
                        this.getDropOffPointBack(journeyIdBack)
                    ];

                    // Wait for all API calls to complete
                    await Promise.all([...outboundPromises, ...returnPromises]);
                } else {
                    // Wait for outbound trip API calls to complete
                    await Promise.all(outboundPromises);
                }
            } catch (error) {
                console.error('Error loading boarding and drop-off points:', error);
            } finally {
                // Reset loading states
                this.loadingBoardingPoints = false;
                this.loadingDropOffPoints = false;
            }
        },

        /*--------- Start One Way Boarding Point -------*/
        async getBoardingPoint(bId) {
            const url = this.$url + `boarding-point/listByScheduleDate`;

            const data = {
                date: localStorage.getItem('dateFrom'),
                id: bId
            }

            let config = {
                method: "POST",
                headers: this.$header,
                data: data,
                url: url
            };

            axios(config).then(response => {
                if (response.status == 200) {
                    if (response.data.header.result == true && response.data.header.statusCode == 200) {
                        // Always set as array
                        let result = response.data.body;
                        if (!Array.isArray(result)) {
                            result = result ? [result] : [];
                        }
                        this.boardingPoint = result;

                        if (this.boardingPoint.length == 1) {
                            this.selectedBoxId = this.boardingPoint[0].id;
                            this.selectedBox = this.boardingPoint[0].address + "  ";
                            this.selectedBoxname = this.boardingPoint[0].name + ' - ' + this.convertTimes(this.boardingPoint[0].time);
                            this.lats = this.boardingPoint[0].lats;
                            this.longs = this.boardingPoint[0].longs;
                            localStorage.setItem('boardingPointId', this.selectedBoxId);
                            localStorage.setItem("boardingpointAddress", this.selectedBox);
                        } else {
                            this.selectedBoxId = "";
                            this.selectedBox = "";
                            localStorage.setItem('boardingPointId', this.selectedBoxId);
                            localStorage.setItem("boardingpointAddress", this.selectedBox);
                        }
                    } else {
                        this.errored = true
                    }
                }
            }).catch(error => {
                console.log(error);
            })
        },

        async getDropOffPoint(dId, retryCount = 0) {
            // Check cache first
            const cacheKey = `dropoff_${dId}`;
            if (this.dropOffPointCache.has(cacheKey)) {
                const cachedData = this.dropOffPointCache.get(cacheKey);
                this.dropOffPoint = cachedData.dropOffPoint;
                this.selectedBoxDownId = cachedData.selectedBoxDownId;
                this.selectedBoxDownname = cachedData.selectedBoxDownname;
                this.selectedBoxDown = cachedData.selectedBoxDown;
                this.latsdropoff = cachedData.latsdropoff;
                this.longsdropoff = cachedData.longsdropoff;
                return;
            }

            const url = this.$url + `drop-off-point/findBySchedule/${dId}`;
            const maxRetries = 3;

            let config = {
                method: "POST",
                headers: this.$header,
                url,
                timeout: 10000 // 10 second timeout
            };
            try {
                const response = await axios(config);

                if (response.status == 200) {
                    if (response.data.header.result == true && response.data.header.statusCode == 200) {
                        this.dropOffPoint = response.data.body;

                        if (response.data.body.length == 1) {
                            for (let i = 0; i < this.dropOffPoint.length; i++) {
                                this.selectedBoxDownId = this.dropOffPoint[0].id;
                                this.selectedBoxDownname = this.dropOffPoint[0].name + ' - ' + this.convertTimes(this.dropOffPoint[0].time);
                                this.selectedBoxDown = this.dropOffPoint[0].address + "  ";
                                this.latsdropoff = this.dropOffPoint[0].lats;
                                this.longsdropoff = this.dropOffPoint[0].longs;
                            }
                            localStorage.setItem('dropOffPointId', this.selectedBoxDownId);
                            localStorage.setItem('dropOffPointName', this.selectedBoxDownname);
                            localStorage.setItem('dropOffPointAddress', this.selectedBoxDown);
                        } else {
                            this.selectedBoxDownId = '';
                            this.selectedBoxDown = '';
                            this.selectedBoxDownname = '';
                            localStorage.setItem('dropOffPointId', this.selectedBoxDownId);
                            localStorage.setItem('dropOffPointName', this.selectedBoxDownname);
                            localStorage.setItem('dropOffPointAddress', this.selectedBoxDown);
                        }

                        // Cache the successful response
                        this.dropOffPointCache.set(cacheKey, {
                            dropOffPoint: this.dropOffPoint,
                            selectedBoxDownId: this.selectedBoxDownId,
                            selectedBoxDownname: this.selectedBoxDownname,
                            selectedBoxDown: this.selectedBoxDown,
                            latsdropoff: this.latsdropoff,
                            longsdropoff: this.longsdropoff
                        });
                    } else {
                        throw new Error('Invalid response from server');
                    }
                } else {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }
            } catch (error) {
                console.error(`Drop-off point API error (attempt ${retryCount + 1}):`, error);

                if (retryCount < maxRetries) {
                    // Exponential backoff: wait 1s, 2s, 4s
                    const delay = Math.pow(2, retryCount) * 1000;

                    setTimeout(() => {
                        this.getDropOffPoint(dId, retryCount + 1);
                    }, delay);
                } else {
                    console.error('Max retries reached for drop-off point API');
                    this.errored = true;
                    // Show user-friendly error message
                    alert('Failed to load drop-off points. Please refresh the page and try again.');
                }
            }
        },

        selectGender(index) {
            this.activeItem = index;
            this.showListDataGen = true;
        },
        selectGenderBack(index) {
            this.activeItem = index;
            this.showListDataGenBack = true;
        },

        setGender(index, value) {
            // Update outbound gender
            this.$set(this.selected, index, value);
            localStorage.setItem('gender', JSON.stringify(this.selected));

            // Update display text
            if (value === 1) {
                this.selectedOption1 = this.$t("message.male");
            } else if (value === 2) {
                this.selectedOption2 = this.$t("message.Female");
            }

            // Auto-copy to return trip if it exists and hasn't been manually set
            if (this.returnTrip && !this.selectedback[index]) {
                this.selectedback[index] = value;
                localStorage.setItem('genderback', JSON.stringify(this.selectedback));
                if (value === 1) {
                    this.selectedOptionBack1 = this.$t("message.male");
                } else if (value === 2) {
                    this.selectedOptionBack2 = this.$t("message.Female");
                }
            }

            this.showListDataGen = false;
        },
        setGenderBack(index, value) {
            // Update return trip gender
            this.$set(this.selectedback, index, value);
            localStorage.setItem('genderback', JSON.stringify(this.selectedback));

            // Update display text
            if (value === 1) {
                this.selectedOptionBack1 = this.$t("message.male");
            } else if (value === 2) {
                this.selectedOptionBack2 = this.$t("message.Female");
            }

            this.showListDataGenBack = false;
        },
        getGender() {
            let check = true;
            for (let i = 0; i < this.selected.length; i++) {
                if (this.selected[i] == 0) {
                    check = false;
                    break;
                }
            }
            return check;
        },
        gettransportationType() {
            const transportationType = localStorage.getItem('transportationType');
            return transportationType;
        },
        gettransportationTypeBack() {
            const transportationTypeBack = localStorage.getItem('transportationTypeBack');
            return transportationTypeBack;
        },

        checkName() {
            // Check outbound names
            const outboundValid = this.fullname.every(name => name && name.trim());
            if (!outboundValid) {
                this.check = false;
                return false;
            }
            // Check return trip names if applicable
            if (this.returnTrip) {
                const returnValid = this.fullnameback.every(name => name && name.trim());
                if (!returnValid) {
                    this.check = false;
                    return false;
                }
            }
            this.check = true;
            return true;
        },

        checkNameBack() {
            let name = [];
            let seatName = this.fullnameback;
            for (let i = 0; i < seatName.length; i++) {
                name.push(seatName[i]);
                if (name == '' || name == undefined) {
                    this.check = false;
                    break;
                } else {
                    return this.check = true;
                }
            }
        },

        getGenderBack() {
            let check = true;
            for (let i = 0; i < this.selectedback.length; i++) {
                if (this.selectedback[i] == 0) {
                    check = false;
                    break;
                }
            }
            return check;
        },

        // checkbox luckydraw
        handleCheckboxChangeluckydraw() {
            let totalluckydraw;
            if (this.isCheckedBox) {
                totalluckydraw = (this.seatNumBack + this.getSeat()) * 0.25;
                this.isUseLuckyDraw = 1;
                // Travel Package Reset
                this.isCheckPackageApply = false;
                this.packageCode = "";
            } else {
                totalluckydraw = 0;
                this.isUseLuckyDraw = 0;
            }
            localStorage.setItem('totalluckydraw', totalluckydraw);

            return totalluckydraw;

        },

        handleCheckboxTravelPackage() {
            // Check if user is logged in first
            const session = localStorage.getItem('session_start_login');
            if (!session) {
                // Use $nextTick to ensure DOM updates after the checkbox state change
                this.$nextTick(() => {
                    this.isCheckPackageApply = false;
                });
                alert("Cannot apply travel package");
                return;
            }

            if (this.isCheckPackageApply) {
                this.handleCheckboxChangeluckydraw();

                this.getTravelPackageCode().then(() => {
                    if (this.packageCode) {
                        this.checkPackageApply();
                    }
                }).catch((error) => {
                    console.error('Error getting travel package code:', error);
                    this.isCheckPackageApply = false;
                });
            } else {
                // Reset package application when unchecked
                this.isPackageApplied = false;
                this.packageCode = "";
                this.discountpackage = 0;
                localStorage.removeItem('packageCode');
                localStorage.removeItem('totalAmount');
            }
        },

        applyCoupon() {
            const normalizedPromoCode = this.normalizePromoValue(this.promoCode);
            this.promoCode = normalizedPromoCode;

            if (!normalizedPromoCode) {
                alert(this.$t('message.enterCouponCode') || 'Please enter a promo code');
                return;
            }

            const promoText = this.normalizePromoValue(this.promoInput);

            const data = {
                code: normalizedPromoCode,
                travelDate: localStorage.getItem('dateFrom'),
                amount: parseFloat(localStorage.getItem('resultTotal')),
                journeyId: localStorage.getItem('journeyid')
            };

            this.couponLoading = true;
            const url = this.$url + `booking/checkCoupon`;
            const config = {
                method: "POST",
                headers: this.$header,
                data,
                url
            };

            axios(config)
                .then((response) => {
                    if (response.status == 200) {
                        if (response.data.header.statusCode == 200) {
                            this.couponError = response.data.body;
                            if (response.data.body.errorStatus == 1) {
                                this.isCouponApplied = false;
                                this.promoCode = "";
                                this.couponResponse = null;
                                this.couponError = this.$t('message.Yourpromotioncode') + promoText + this.$t('message.isinvalid');
                            } else if (response.data.body.errorStatus == 2) {
                                this.isCouponApplied = false;
                                this.promoCode = "";
                                this.couponResponse = null;
                                this.couponError = this.$t('message.Yourpromotioncode') + promoText + this.$t('message.hasexpired');
                            } else if (response.data.body.errorStatus == 3) {
                                this.isCouponApplied = false;
                                this.promoCode = "";
                                this.couponResponse = null;
                                this.couponError = this.$t('message.Yourpromotioncode') + promoText + this.$t('message.Thepricenotmatchwithticketprice');
                            } else {
                                this.isCouponApplied = true;
                                this.couponResponse = response.data.body;
                                localStorage.setItem('promoCode', this.couponResponse.code);
                                this.promoCode = this.couponResponse.code;
                                this.couponError = '';
                            }
                        } else {
                            this.isCouponApplied = false;
                            this.promoCode = "";
                            this.couponResponse = null;
                            this.couponError = response.data.body.msg;
                        }
                    }
                })
                .catch((error) => {
                    console.error('Error in applyCoupon:', error);
                    this.isCouponApplied = false;
                    this.promoCode = "";
                    this.couponResponse = null;
                })
                .finally(() => {
                    this.couponLoading = false;
                    this.isCheckCouponApply = false;
                    if (this.isCouponApplied && !this.couponError && this.showCouponModal) {
                        this.showCouponModal = false;
                    }
                });
        },

        unapplyCoupon() {
            this.isCouponApplied = false;
            this.isCheckCouponApply = false;
            this.promoCode = "";
            this.couponResponse = null;
            this.couponError = "";
            localStorage.removeItem('promoCode');
            localStorage.removeItem('couponCode');
        },

        removeCoupon() {
            this.unapplyCoupon();
        },

        openCouponModal() {
            if (this.returnTrip || this.isCheckPackageApply) {
                return;
            }
            this.promoInput = this.normalizePromoValue(this.promoCode);
            this.promoError = '';
            this.couponError = '';
            this.showCouponModal = true;
        },

        closeCouponModal() {
            this.showCouponModal = false;
            this.promoError = '';
            this.couponError = '';
        },

        applyPromoFromModal() {
            const normalizedPromoInput = this.normalizePromoValue(this.promoInput);
            if (!normalizedPromoInput) {
                this.promoError = this.$t('message.enterCouponCode') || 'Please enter a promo code';
                this.couponError = this.promoError;
                return;
            }

            this.couponError = '';
            this.promoError = '';
            this.promoInput = normalizedPromoInput;
            this.promoCode = normalizedPromoInput;
            this.isCheckCouponApply = true;
            this.applyCoupon();
        },
        storeBookingResponseToLocalStorage(bookingBody) {
            const firstOrderPayment = Array.isArray(bookingBody?.orderPaymentLists) && bookingBody.orderPaymentLists.length
                ? bookingBody.orderPaymentLists[0]
                : {};

            const discount = firstOrderPayment.discount ?? bookingBody?.discount ?? "0.00";
            const discountPercent = firstOrderPayment.disTravel ?? bookingBody?.discountPercent ?? "0";
            const total = firstOrderPayment.total ?? bookingBody?.total ?? bookingBody?.grandTotal ?? "0.00";
            const subTotal = firstOrderPayment.grandTotal ?? bookingBody?.subTotal ?? bookingBody?.grandTotal ?? total;

            localStorage.setItem("discount", String(discount));
            localStorage.setItem("discountPercent", String(discountPercent));
            localStorage.setItem("total", String(total));
            localStorage.setItem("subTotal", String(subTotal));

            localStorage.setItem(
                "orderPaymentLists",
                JSON.stringify(Array.isArray(bookingBody?.orderPaymentLists) ? bookingBody.orderPaymentLists : [])
            );
            localStorage.setItem(
                "paymentMethods",
                JSON.stringify(Array.isArray(bookingBody?.paymentMethods) ? bookingBody.paymentMethods : [])
            );
            localStorage.setItem(
                "confirmBookingInformation",
                JSON.stringify(Array.isArray(bookingBody?.confirmBookingInformation) ? bookingBody.confirmBookingInformation : [])
            );
        },

        processPayment() {
            if (this.loadingOneWay) return;
            // this.loadingOneWay = true;
            if (this.seatLabels.length == this.fullname.length && this.checkName()) {

                if (!this.getGender()) {
                    // alert(this.$t('message.pleaseselectgender'));
                    this.showAlertfields = true;
                    return;
                }

                // Only require phone for lucky draw
                if (this.isUseLuckyDraw == 1 && !this.phone) {
                    alert("Please input telephone number for lucky draw");
                    return;
                }

                if (localStorage.getItem('boardingPointId') == '') {
                    // alert(this.$t('message.Pleaseselectboardingpoint'));
                    this.showAlertfields = true;
                    return;
                }

                if (localStorage.getItem('dropOffPointId') == '') {
                    // alert("Please Select Drop Off point");
                    this.showAlertfields = true;
                    return;
                }

                const session = localStorage.getItem('session_start_login');
                this.isLoggedIn = !!session;
                const emailTrimmed = (this.email || '').trim().toLowerCase();
                const phoneTrimmed = (this.phone || '').trim();

                if (this.email !== emailTrimmed) {
                    this.email = emailTrimmed;
                }
                if (this.phone !== phoneTrimmed) {
                    this.phone = phoneTrimmed;
                }

                if (this.isLoggedIn) {
                    if (!emailTrimmed && !phoneTrimmed) {
                        this.msg['email'] = this.$t('message.yourEmailTelephoneNumberRequired');
                        this.showAlertfields = true;
                        return;
                    }
                    if (emailTrimmed && !this.validateEmail(emailTrimmed)) {
                        this.showAlertfields = true;
                        return;
                    }
                } else {
                    if (!this.validateEmail(emailTrimmed)) {
                        this.showAlertfields = true;
                        return;
                    }
                }

                // Only validate phone if provided or lucky draw selected
                if (phoneTrimmed || this.isUseLuckyDraw == 1) {
                    const regex = /^[+]?\d{1,3}[-.\s]?\d{1,14}$/;
                    if (!regex.test(phoneTrimmed) ||
                        (phoneTrimmed.length != this.maxLength && phoneTrimmed.length != this.maxLengths)) {
                        this.phoneNumberError['phone'] = '';
                        // alert("Invalid phone number");
                        return;
                    }
                }

                // Add nationality validation
                this.syncNationalityIdsFromNames(false);
                const seatCount = this.seatLabels.length;
                for (let i = 0; i < seatCount; i++) {
                    if (!this.nationalityid[i]) {
                        // alert(this.$t('message.pleaseSelectNationality') + ` (${this.$t('message.passenger')} ${i + 1})`);
                        // alert(this.$t('message.pleaseSelectNationality'));
                        this.showAlertfields = true;
                        return;
                    }
                }

                localStorage.setItem('email', emailTrimmed);
                localStorage.setItem('phone', phoneTrimmed);

                if (this.ticktermandprivacy === false) {
                    this.showAlert = true;
                    this.loadingOneWay = false;
                    return;
                } else {
                    this.showAlert = false;
                    this.loadingOneWay = true;
                }

                // Prepare booking data
                const bookingData = {
                    boardingPointId: parseInt(localStorage.getItem('boardingPointId')),
                    dropOffId: parseInt(localStorage.getItem('dropOffPointId')),
                    email: emailTrimmed,

                    journeyDate: [localStorage.getItem('dateFrom')],
                    journeyId: [localStorage.getItem('journeyid')],
                    journeyType: parseInt(localStorage.getItem('types')),
                    nationally: localStorage.getItem("selectNational"),
                    seatNationallyId: this.nationalityid, // Ensure no null values
                    seatGender: this.selected,
                    seatJourney: Array(this.seatLabels.length).fill(localStorage.getItem('journeyid')),
                    seatName: this.fullname,
                    seatNum: localStorage.getItem('seat').split(","),
                    seatPrice: this.isCheckPackageApply ?
                        // When travel package is applied, use original prices per seat
                        Array(this.seatLabels.length).fill(
                            (parseFloat(localStorage.getItem('resultTotal')) / this.seatLabels.length).toFixed(2)
                        ) :
                        // When no travel package, use regular prices
                        Array(this.seatLabels.length).fill(localStorage.getItem('price')),
                    telephone: phoneTrimmed || "", // Make phone optional
                    isUseLuckyDraw: parseInt(this.isUseLuckyDraw),
                    totalAmount: this.isCheckPackageApply ?
                        parseFloat(localStorage.getItem('resultTotal')) :
                        parseFloat(localStorage.getItem('resultTotal')),
                    totalDiscount: this.disConut(),
                    totalSeat: String(this.getSeat()),
                    session: localStorage.getItem('session_start_login'),
                    packageTravelCode: this.isCheckPackageApply ? localStorage.getItem('packageCode') : '',
                    couponCode: this.isCouponApplied ? (this.promoCode || this.promoInput.trim() || localStorage.getItem('promoCode')) : ''
                };

                const url = this.$url + `booking/confirm`;
                const config = {
                    method: "POST",
                    headers: this.$header,
                    data: qs.stringify(bookingData),
                    url
                };


                axios(config)
                    .then((response) => {
                        if (response.status == 200) {
                            if (response.data.header.result && response.data.header.statusCode == 200) {
                                if (response.data.body.status == 1) {
                                    this.storeBookingResponseToLocalStorage(response.data.body);

                                    this.info = response.data.body;
                                    this.transactionId = this.info.transactionId;
                                    setTimeout(() => {
                                        this.loadingOneWay = false; // Reset loading state
                                        this.$router.push({
                                            path: "/payment-cart",
                                            query: {
                                                transactionId: this.info.transactionId
                                            }
                                        });
                                    }, 2000);
                                } else if (response.data.body.status == 2) {
                                    this.info = response.data.body;
                                    this.transactionId = this.info.transactionId;
                                    setTimeout(() => {
                                        this.loadingOneWay = false; // Reset loading state
                                        this.$router.push({
                                            path: "/payment-success",
                                            query: {
                                                transactionId: this.info.transactionId
                                            }
                                        });
                                    }, 2000);
                                } else {
                                    this.loadingOneWay = false; // Reset loading state
                                    if (response.data.body.msg == "Sorry, some seats you selected are not available.") {
                                        alert("Seat is not available, please chose your trip again.");
                                        this.$router.push("/");
                                    }
                                    // else {
                                    //     alert("Something went wrong, Please try it again.");
                                    //     this.$router.push("/");
                                    // }
                                }
                            } else {
                                this.loadingOneWay = false; // Reset loading state
                                this.$router.go();
                            }
                        }
                    })
                    .catch((error) => {
                        console.error("Booking API error:", error);
                        this.loadingOneWay = false; // Reset loading state
                        // alert("An error occurred during booking. Please try again.");
                    });
            } else {
                // alert(this.$t('message.pleaseinputyourname'));
                this.showAlertfields = true;
            }
        },
        /*--------- End One Way Boarding Point -------*/

        /*--------- Start Two Way Boarding Point -------*/
        async getBoardingPointBack(bIdBack) {
            const url = this.$url + `boarding-point/listByScheduleDate`;

            const data = {
                date: localStorage.getItem('dateTo'),
                id: bIdBack
            }

            let config = {
                method: "POST",
                headers: this.$header,
                data: data,
                url: url
            };
            axios(config).then(response => {
                if (response.status == 200) {
                    if (response.data.header.result == true && response.data.header.statusCode == 200) {
                        this.boardingPointBack = response.data.body;
                        // let boardingPointIdBack = [];
                        if (response.data.body.length == 1) {
                            for (let i = 0; i < this.boardingPointBack.length; i++) {
                                this.selectedBoxIdBack = this.boardingPointBack[0].id;
                                this.selectedBoxBackDownname = this.boardingPointBack[0].name + "  " + this.convertTimes(this.boardingPointBack[0].time);
                                this.selectedBoxBack = this.boardingPointBack[0].address;
                                this.latspointBack = this.boardingPointBack[0].lats;
                                this.longsPointBack = this.boardingPointBack[0].longs;
                            }
                            localStorage.setItem('boardingPointIdBack', this.selectedBoxIdBack);
                            localStorage.setItem('boardingPointNameBack', this.selectedBoxBack);
                            localStorage.setItem('boardingPointNameBackDown', this.selectedBoxBackDownname);
                        } else {
                            this.selectedBoxIdBack = '';
                            this.selectedBoxBack = '';
                            // this.selectedBoxBackDownname = '';
                            localStorage.setItem('boardingPointIdBack', this.selectedBoxIdBack);
                            localStorage.setItem('boardingPointNameBack', this.selectedBoxBack);
                            localStorage.setItem('boardingPointNameBackDown', this.selectedBoxBackDownname);
                        }

                    } else {
                        this.errored = true;
                    }
                }
            }).catch(error => {
                console.log(error);
            })
        },
        async getDropOffPointBack(dIdBack) {
            const url = this.$url + `drop-off-point/findBySchedule/${dIdBack}`;
            let config = {
                method: "POST",
                headers: this.$header,
                url
            };
            axios(config).then(response => {
                if (response.status == 200) {
                    if (response.data.header.result == true && response.data.header.statusCode == 200) {
                        this.dropOffPointBack = response.data.body;
                        // let dropOffPointIdBack = response.data.body;
                        if (response.data.body.length == 1) {
                            for (let i = 0; i < this.dropOffPointBack.length; i++) {
                                this.selectedBoxIdBackoffDown = this.dropOffPointBack[0].id;
                                this.selectedBoxBackoffDownname = this.dropOffPointBack[0].name + "  " + this.convertTimes(this.dropOffPointBack[0].time);
                                this.selectedBoxBackoffDown = this.dropOffPointBack[0].address;
                                this.latspointBackoff = this.dropOffPointBack[0].lats;
                                this.longsPointBackoff = this.dropOffPointBack[0].longs;
                            }
                            localStorage.setItem('dropOffPointIdBack', this.selectedBoxIdBackoffDown);
                            localStorage.setItem('dropOffPointNameBack', this.selectedBoxBackoffDown);
                            localStorage.setItem('dropOffPointNameBackDown', this.selectedBoxBackoffDownname);
                        } else {
                            this.selectedBoxIdBackoffDown = '';
                            this.selectedBoxBackoffDown = '';
                            this.selectedBoxBackoffDownname = '';
                            localStorage.setItem('dropOffPointIdBack', this.selectedBoxIdBackoffDown);
                            localStorage.setItem('dropOffPointNameBack', this.selectedBoxBackoffDown);
                            localStorage.setItem('dropOffPointNameBackDown', this.selectedBoxBackoffDownname);
                        }

                    } else {
                        this.errored = true
                    }
                }
            }).catch(error => {
                console.log(error);
            })
        },
        processPaymentTwo() {
            if (this.loadingReturn) return;
            if (this.seatLabels.length == this.fullname.length && this.checkName()) {
                const session = localStorage.getItem('session_start_login');
                this.isLoggedIn = !!session;
                const emailTrimmed = (this.email || '').trim().toLowerCase();
                const phoneTrimmed = (this.phone || '').trim();

                if (this.email !== emailTrimmed) {
                    this.email = emailTrimmed;
                }
                if (this.phone !== phoneTrimmed) {
                    this.phone = phoneTrimmed;
                }

                // Validate email and gender
                if (!this.getGender() && !this.getGenderBack() && !emailTrimmed && !phoneTrimmed) {
                    // alert("Please input Email and Select Gender");
                    this.showAlertfields = true;
                    return;
                }

                if (this.isLoggedIn) {
                    if (!emailTrimmed && !phoneTrimmed) {
                        this.msg['email'] = this.$t('message.yourEmailTelephoneNumberRequired');
                        this.showAlertfields = true;
                        return;
                    }
                    if (emailTrimmed && !this.validateEmail(emailTrimmed)) {
                        this.showAlertfields = true;
                        return;
                    }
                } else {
                    if (!this.validateEmail(emailTrimmed)) {
                        this.showAlertfields = true;
                        return;
                    }
                }


                if (!this.getGender() || !this.getGenderBack()) {
                    // alert(this.$t('message.pleaseselectgender'));
                    this.showAlertfields = true;
                    return;
                }

                // Validate boarding points
                if (localStorage.getItem('boardingPointId') == '') {
                    // alert(this.$t('message.Pleaseselectboardingpoint'));
                    this.showAlertfields = true;
                    return;
                }

                if (localStorage.getItem('dropOffPointId') == '') {
                    // alert("Please Select Drop Off point");
                    this.showAlertfields = true;
                    return;
                }

                if (localStorage.getItem('boardingPointIdBack') == '') {
                    // alert("Please Select boarding point for return trip");
                    this.showAlertfields = true;
                    return;
                }

                if (localStorage.getItem('dropOffPointIdBack') == '') {
                    // alert("Please Select Drop Off point for return trip");
                    this.showAlertfields = true;
                    return;
                }

                // Validate phone if lucky draw selected
                if (this.isUseLuckyDraw == 1 && !phoneTrimmed) {
                    alert("Please input telephone number for lucky draw");
                    return;
                }

                // Validate phone format if provided
                if (phoneTrimmed) {
                    const regex = /^[+]?\d{1,3}[-.\s]?\d{1,14}$/;
                    if (!regex.test(phoneTrimmed) ||
                        (phoneTrimmed.length != this.maxLength && phoneTrimmed.length != this.maxLengths)) {
                        this.phoneNumberError['phone'] = '';
                        // alert("Invalid phone number");
                        return;
                    }
                }

                // Validate nationalities for outbound trip
                this.syncNationalityIdsFromNames(false);
                this.syncNationalityIdsFromNames(true);
                const outboundSeatCount = this.seatLabels.length;
                for (let i = 0; i < outboundSeatCount; i++) {
                    if (!this.nationalityid[i]) {
                        // alert(this.$t('message.pleaseSelectNationality') + ` (${this.$t('message.passenger')} ${i + 1} - ${this.$t('message.roundTrip')})`);
                        this.showAlertfields = true;
                        return;
                    }
                }

                // Validate nationalities for return trip
                const returnSeatCount = this.seatLabelbacks.length;
                for (let i = 0; i < returnSeatCount; i++) {
                    if (!this.nationalityidBack[i]) {
                        // alert(this.$t('message.pleaseSelectNationality') + ` (${this.$t('message.passenger')} ${i + 1} - ${this.$t('message.roundTrip')})`);
                        this.showAlertfields = true;
                        return;
                    }
                }
                if (this.ticktermandprivacy === false) {
                    this.showAlert = true;
                    this.loadingReturn = false;
                    return;
                } else {
                    this.showAlert = false;
                    this.loadingReturn = true;
                }
                // Get seat data
                const seatData = localStorage.getItem('seat');
                const seatBackData = localStorage.getItem('seatback');

                if (!seatData || !seatBackData) {
                    alert("Missing seat information. Please select seats again.");
                    return;
                }

                // Prepare booking data
                const bookingData = {
                    boardingPointId: [
                        parseInt(localStorage.getItem('boardingPointId')),
                        parseInt(localStorage.getItem('boardingPointIdBack'))
                    ],
                    dropOffId: [
                        parseInt(localStorage.getItem('dropOffPointId')),
                        parseInt(localStorage.getItem('dropOffPointIdBack'))
                    ],
                    email: this.email,
                    journeyDate: [
                        localStorage.getItem('dateFrom'),
                        localStorage.getItem('dateTo')
                    ],
                    journeyId: [
                        localStorage.getItem('journeyid'),
                        localStorage.getItem('journeyidback')
                    ],
                    journeyType: 2,
                    nationally: localStorage.getItem("selectNational"),
                    seatNationallyId: [
                        ...this.nationalityid, // Outbound trip nationalities
                        ...this.nationalityidBack // Return trip nationalities
                    ],
                    seatGender: [...this.selected, ...this.selectedback],
                    seatJourney: [
                        ...Array(this.seatLabels.length).fill(localStorage.getItem('journeyid')),
                        ...Array(this.seatLabelbacks.length).fill(localStorage.getItem('journeyidback'))
                    ],
                    seatName: [...this.fullname, ...this.fullnameback],
                    seatNum: [
                        ...seatData.split(",").filter(s => s),
                        ...seatBackData.split(",").filter(s => s)
                    ],
                    seatPrice: this.isCheckPackageApply ? [
                        // When travel package is applied, use original prices per seat
                        ...Array(this.seatLabels.length).fill(
                            (parseFloat(localStorage.getItem('price')) / this.seatLabels.length).toFixed(2)
                        ),
                        ...Array(this.seatLabelbacks.length).fill(
                            (parseFloat(localStorage.getItem('priceback')) / this.seatLabelbacks.length).toFixed(2)
                        )
                    ] : [
                        // When no travel package, use regular prices
                        ...Array(this.seatLabels.length).fill(localStorage.getItem('price')),
                        ...Array(this.seatLabelbacks.length).fill(localStorage.getItem('priceback'))
                    ],
                    telephone: phoneTrimmed || "",
                    totalAmount:this.isCheckCouponApply ? (parseFloat(this.calculateGrandTotal())) : (parseFloat(localStorage.getItem('resultTotal'))+ parseFloat(localStorage.getItem('resultTotalBack'))), // Use the calculated grand total
                    // totalDiscount: this.isCheckPackageApply ?
                    //     this.totalDiscosunt() : 
                    //     this.disConut() + this.disConutBack(), 
                    totalDiscount: this.totalDiscosunt(), // Use the combined discount from both trips
                    isUseLuckyDraw: parseInt(this.isUseLuckyDraw),
                    totalSeat: String(this.getSeat() + this.getSeatBack()),
                    session: localStorage.getItem('session_start_login'),
                    packageTravelCode: this.isCheckPackageApply ? localStorage.getItem('packageCode') : ''
                };

                // Make API call
                const url = this.$url + `booking/confirm`;
                const config = {
                    method: "POST",
                    headers: this.$header,
                    data: qs.stringify(bookingData),
                    url
                };
                localStorage.setItem('email', emailTrimmed);
                localStorage.setItem('phone', phoneTrimmed);

                axios(config)
                    .then((response) => {
                        if (response.status == 200) {
                            if (response.data.header.result && response.data.header.statusCode == 200) {
                                if (response.data.body.status == 1) {
                                    this.storeBookingResponseToLocalStorage(response.data.body);
                                    setTimeout(() => {
                                        this.info = response.data.body;
                                        this.transactionId = this.info.transactionId;
                                        this.loadingReturn = false; // Reset loading state
                                        this.$router.push({
                                            path: "/payment-cart",
                                            query: {
                                                transactionId: this.info.transactionId
                                            }
                                        });
                                    }, 2000);
                                } else if (response.data.body.status == 2) {
                                    this.info = response.data.body;
                                    this.transactionId = this.info.transactionId;
                                    setTimeout(() => {
                                        this.loadingReturn = false; // Reset loading state
                                        this.$router.push({
                                            path: "/payment-success",
                                            query: {
                                                transactionId: this.info.transactionId
                                            }
                                        });
                                    }, 2000);
                                } else {
                                    this.loadingReturn = false; // Reset loading state
                                    if (response.data.body.msg == "Sorry, some seats you selected are not available.") {
                                        alert("Seat is not available, please chose your trip again.");
                                        this.$router.push("/");
                                    }
                                    // else {
                                    //     alert("Something went wrong, Please try it again.");
                                    //     this.$router.push("/");
                                    // }
                                }
                            } else {
                                this.loadingReturn = false; // Reset loading state
                                this.$router.go();
                            }
                        }
                    })
                    .catch((error) => {
                        console.error("Booking API error:", error);
                        this.loadingReturn = false; // Reset loading state
                        // alert("An error occurred during booking. Please try again.");
                    });
            } else {
                // alert("Please input your name");
                this.showAlertfields = true;
            }
        },
        /*--------- End Two Way Boarding Point -------*/
        validatePhoneNumber(value) {
            const rawValue = value && value.target ? value.target.value : value;
            const trimmedValue = String(rawValue || '').trim();

            // If empty, it's not invalid (required validation is separate)
            if (!trimmedValue) {
                this.phoneNumberinvalid = false;
                this.phoneNumberError['phone'] = '';
                return true;
            }

            // Check if it's a valid phone number format
            const digitsOnly = trimmedValue.replace(/[^0-9]/g, '');
            const isValid = digitsOnly.length >= 9 && digitsOnly.length <= 10;

            this.phoneNumberinvalid = !isValid;
            this.phoneNumberError['phone'] = isValid ? '' : '';

            return isValid;
        },
        validateEmailRealTime() {
            const trimmedEmail = (this.email || '').trim().toLowerCase();

            // Update email to lowercase
            if (this.email) {
                this.email = trimmedEmail;
            }

            // If empty, it's not invalid (required validation is separate)
            if (!trimmedEmail) {
                this.emailinvalid = false;
                return;
            }

            // Check if it's a valid email or phone format
            const isValid = this.isValidEmailFormat(trimmedEmail) || this.isValidPhoneFormat(trimmedEmail);
            this.emailinvalid = !isValid;
        },
        removefixscroll() {
            const htmlElement = document.querySelector('html');
            htmlElement.classList.remove('fix-scroll');
        },
        validateEmail(value) {
            const contact = (value || '').trim().toLowerCase();
            const isLoggedIn = this.isLoggedIn;

            // Update the email field to lowercase
            if (this.email && this.isValidEmailFormat(contact)) {
                this.email = contact;
            }

            if (!contact) {
                if (isLoggedIn) {
                    this.msg['email'] = '';
                    return true;
                }
                this.msg['email'] = '';
                return false;
            }

            if (this.isValidEmailFormat(contact) || this.isValidPhoneFormat(contact)) {
                this.msg['email'] = '';
                return true;
            }

            this.msg['email'] = '';
            return false;
        },
        isValidEmailFormat(value) {
            const emailPattern = /^[\w+.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailPattern.test(value);
        },
        isValidPhoneFormat(value) {
            if (!value) return false;
            const digitsOnly = value.replace(/[^0-9]/g, '');
            return digitsOnly.length === this.maxLength || digitsOnly.length === this.maxLengths;
        },
        limitStr(string, limit) {
            let str = string;

            if (typeof str === 'string' && str.length > limit) {
                str = str.slice(0, limit) + '...';
            }

            return str;
        },
        initializeGenderFromProfile() {
            const profileGender = localStorage.getItem('genderProfile');
            if (profileGender) {
                // Convert gender value to number if needed
                const genderValue = parseInt(profileGender);

                // Initialize arrays if not already done
                if (!this.selected.length) {
                    this.selected = new Array(this.seatLabels.length).fill(0);
                }
                if (!this.selectedback.length) {
                    this.selectedback = new Array(this.seatLabelbacks.length).fill(0);
                }

                // Set gender for first passenger
                this.selected[0] = genderValue;
                this.selectedback[0] = genderValue;

                // Update display text
                if (genderValue === 1) {
                    this.selectedOption1 = this.$t("message.male");
                    this.selectedOptionBack1 = this.$t("message.male");
                } else if (genderValue === 2) {
                    this.selectedOption2 = this.$t("message.Female");
                    this.selectedOptionBack2 = this.$t("message.Female");
                }

                // Store in localStorage
                localStorage.setItem('gender', this.selected);
                localStorage.setItem('genderback', this.selectedback);
            }
        },
        initializePassengerNames() {
            const profileName = localStorage.getItem('nameProfile');

            const seatLabels = localStorage.getItem('seatlabel')?.split(',').filter(s => s) || [];
            const seatLabelsBack = localStorage.getItem('seatlabelback')?.split(',').filter(s => s) || [];

            this.fullname = new Array(seatLabels.length).fill('');
            if (profileName) {
                this.fullname[0] = profileName;
            }

            if (seatLabelsBack.length > 0) {
                this.fullnameback = new Array(seatLabelsBack.length).fill('');
                if (profileName) {
                    this.fullnameback[0] = profileName;
                }
            }
        },
        getDiscountPercentage() {
            if (this.isCheckPackageApply) {
                return this.packagedis;
            }

            if (this.returnTrip) {
                if (localStorage.getItem('priceOriginal') === "" ||
                    localStorage.getItem('priceOriginal') === null) {
                    return localStorage.getItem('disPercent');
                }
                return localStorage.getItem('disPercentBack');
            }

            return localStorage.getItem('disPercent');
        },
        // Add helper function for rounding discount values
        roundDiscount(amount) {
            const value = parseFloat(amount);
            if (isNaN(value)) return "0.00";
            // Round to 2 decimal places properly handling JS floating point issues
            const rounded = Math.round((value + Number.EPSILON) * 100) / 100;
            return rounded.toFixed(2);
        },
        hideNationalityDropdown() {
            this.showNationalityDropdown = false;
        },

        setNationality(index, value) {
            this.$set(this.nationality, index, value);
            const resolvedId = this.resolveNationalityIdByName(value);
            this.$set(this.nationalityid, index, resolvedId);

            // Store in localStorage - use first passenger's nationality as default
            localStorage.setItem('selectNational', value);
            localStorage.setItem('nationalitynamelist', this.nationality.join(','));

            this.showNationalityDropdown = false;
        },
        selectNationality(index) {
            this.activeNationalityItem = index;
            this.showNationalityDropdown = true;
        },
        initializeNationality() {
            const seatLabels = localStorage.getItem('seatlabel')?.split(',').filter(s => s) || [];
            const seatLabelsBack = localStorage.getItem('seatlabelback')?.split(',').filter(s => s) || [];
            const storedNationalityNames = (localStorage.getItem('nationalitynamelist') || '').split(',').filter(s => s);
            const storedNationalityNamesBack = (localStorage.getItem('nationalitynamelistback') || '').split(',').filter(s => s);

            const existingNationality = Array.isArray(this.nationality) ? [...this.nationality] : [];
            const existingNationalityId = Array.isArray(this.nationalityid) ? [...this.nationalityid] : [];
            const existingNationalityBack = Array.isArray(this.nationalityBack) ? [...this.nationalityBack] : [];
            const existingNationalityIdBack = Array.isArray(this.nationalityidBack) ? [...this.nationalityidBack] : [];

            this.nationality = Array.from({ length: seatLabels.length }, (_, index) => {
                return existingNationality[index] || storedNationalityNames[index] || '';
            });
            this.nationalityid = Array.from({ length: seatLabels.length }, (_, index) => {
                return existingNationalityId[index] || '';
            });
            this.nationalityBack = Array.from({ length: seatLabelsBack.length }, (_, index) => {
                return existingNationalityBack[index] || storedNationalityNamesBack[index] || '';
            });
            this.nationalityidBack = Array.from({ length: seatLabelsBack.length }, (_, index) => {
                return existingNationalityIdBack[index] || '';
            });

            const storedId = localStorage.getItem('nationalityId');
            const storedName = localStorage.getItem('nationalityIdProfile');

            if (storedName) {
                if (this.nationality.length > 0 && !this.nationality[0]) {
                    this.$set(this.nationality, 0, storedName);
                }
                if (this.returnTrip && this.nationalityBack.length > 0 && !this.nationalityBack[0]) {
                    this.$set(this.nationalityBack, 0, storedName);
                }
                if (!localStorage.getItem('selectNational')) {
                    localStorage.setItem('selectNational', storedName);
                }
            }
            if (storedId) {
                if (this.nationalityid.length > 0 && !this.nationalityid[0]) {
                    this.$set(this.nationalityid, 0, storedId);
                }
                if (this.returnTrip && this.nationalityidBack.length > 0 && !this.nationalityidBack[0]) {
                    this.$set(this.nationalityidBack, 0, storedId);
                }
            }

            localStorage.setItem('nationalitynamelist', this.nationality.join(','));
            localStorage.setItem('nationalitynamelistback', this.nationalityBack.join(','));
        },
        selectNationalityBack(index) {
            this.showNationalityDropdownBack = true;
            this.activeNationalityItemBack = index;
        },

        hideNationalityDropdownBack() {
            this.showNationalityDropdownBack = false;
            this.activeNationalityItemBack = null;
        },

        resolveNationalityIdByName(name) {
            const normalizedName = String(name || '').trim().toLowerCase();
            if (!normalizedName || !Array.isArray(this.listnation)) {
                return '';
            }

            const match = this.listnation.find((nation) => {
                const nationName = String(nation?.name || nation?.nationalityName || nation?.nationality || '').trim().toLowerCase();
                return nationName && nationName === normalizedName;
            });

            return match ? String(match.id ?? match.nationalityId ?? '') : '';
        },

        syncNationalityIdsFromNames(isReturn = false) {
            const names = isReturn ? this.nationalityBack : this.nationality;
            const ids = isReturn ? this.nationalityidBack : this.nationalityid;
            const seatCount = Array.isArray(names) ? names.length : 0;

            for (let i = 0; i < seatCount; i++) {
                if (ids[i]) {
                    continue;
                }

                const resolvedId = this.resolveNationalityIdByName(names[i]);
                if (resolvedId) {
                    this.$set(ids, i, resolvedId);
                }
            }
        },

        setNationalityBack(index, value) {
            this.$set(this.nationalityBack, index, value);
            const resolvedId = this.resolveNationalityIdByName(value);
            this.$set(this.nationalityidBack, index, resolvedId);
            localStorage.setItem('nationalitynamelistback', this.nationalityBack.join(','));
            this.hideNationalityDropdownBack();
        },
        filterNations(event) {
            const searchTerm = event.target.value.toLowerCase();
            if (!searchTerm) {
                this.filteredNations = [...this.listnation];
            } else {
                this.filteredNations = this.listnation.filter(nation =>
                    nation.name.toLowerCase().includes(searchTerm)
                );
            }
        },
        cleanupNationalityData() {
            // Clear nationality arrays
            this.nationality = [];
            this.nationalityBack = [];
            this.nationalityid = [];
            this.nationalityidBack = [];
            this.filteredNations = [];
            this.listnation = [];

            // Reset dropdowns
            this.showListDataNation = false;
            this.activeNationalityItem = null;
            this.activeNationalityItemBack = null;
        },
        beforeDestroy() {
            // Clear nationality data when component is destroyed
            this.nationality = [];
            this.nationalityBack = [];
            this.nationalityid = [];
            this.nationalityidBack = [];
            this.filteredNations = [];
            this.listnation = [];
            this.showListDataNation = false;
            this.activeNationalityItem = null;
            this.activeNationalityItemBack = null;
            document.removeEventListener('click', this.handleClickOutside);
        },
        handleClickOutside(event) {
            // Check if click is outside the boarding point dropdowns
            const boardingPointDropdowns = document.querySelectorAll('.custom-select');
            let clickedInside = false;

            boardingPointDropdowns.forEach(dropdown => {
                if (dropdown.contains(event.target)) {
                    clickedInside = true;
                }
            });

            if (!clickedInside) {
                // Close all dropdowns
                this.open = false;
                this.open1 = false;
                this.open2 = false;
                this.open3 = false;
            }
        },
        initializeArrays() {
            // Get seat counts
            const seatCount = this.getSeat();

            // Initialize arrays with empty values
            this.nationality = new Array(seatCount).fill('');
            this.nationalityid = new Array(seatCount).fill('');

            if (this.returnTrip) {
                this.nationalityBack = new Array(seatCount).fill('');
                this.nationalityidBack = new Array(seatCount).fill('');
            }
        },
        // initializeGenderArrays() {
        //     // Get seat counts from localStorage
        //     const seatLabels = localStorage.getItem('seatlabel')?.split(',').filter(s => s) || [];
        //     const seatLabelsBack = localStorage.getItem('seatlabelback')?.split(',').filter(s => s) || [];

        //     let storedGender = [];
        //     let storedGenderBack = [];

        //     try {
        //         storedGender = JSON.parse(localStorage.getItem('gender') || '[]');
        //     } catch (error) {
        //         storedGender = [];
        //     }

        //     try {
        //         storedGenderBack = JSON.parse(localStorage.getItem('genderback') || '[]');
        //     } catch (error) {
        //         storedGenderBack = [];
        //     }

        //     const existingSelected = Array.isArray(this.selected) ? [...this.selected] : [];
        //     const existingSelectedBack = Array.isArray(this.selectedback) ? [...this.selectedback] : [];

        //     // Initialize outbound gender array
        //     this.selected = Array.from(
        //         { length: seatLabels.length },
        //         (_, index) => Number(existingSelected[index] || storedGender[index] || 0)
        //     );

        //     // Initialize return trip gender array if needed
        //     if (this.returnTrip) {
        //         this.selectedback = Array.from(
        //             { length: seatLabelsBack.length },
        //             (_, index) => Number(existingSelectedBack[index] || storedGenderBack[index] || 0)
        //         );
        //     } else {
        //         this.selectedback = [];
        //     }

        //     // Set first passenger's gender from profile if available
        //     const profileGender = localStorage.getItem('genderProfile');
        //     if (profileGender) {
        //         const genderValue = parseInt(profileGender);
        //         if (this.selected.length > 0 && !this.selected[0]) {
        //             this.selected[0] = genderValue;
        //         }
        //         if (this.returnTrip && this.selectedback.length > 0 && !this.selectedback[0]) {
        //             this.selectedback[0] = genderValue;
        //         }
        //     }

        //     if (this.selected[0] === 1) {
        //         this.selectedOption1 = this.$t('message.male');
        //     } else if (this.selected[0] === 2) {
        //         this.selectedOption2 = this.$t('message.Female');
        //     }

        //     if (this.selectedback[0] === 1) {
        //         this.selectedOptionBack1 = this.$t('message.male');
        //     } else if (this.selectedback[0] === 2) {
        //         this.selectedOptionBack2 = this.$t('message.Female');
        //     }

        //     localStorage.setItem('gender', JSON.stringify(this.selected));
        //     localStorage.setItem('genderback', JSON.stringify(this.selectedback));

        //     localStorage.setItem('gender', JSON.stringify(this.selected));
        //     localStorage.setItem('genderback', JSON.stringify(this.selectedback));
        // },
         initializeGenderArrays() {
            // Get seat counts from localStorage
            const seatLabels = localStorage.getItem('seatlabel')?.split(',').filter(s => s) || [];
            const seatLabelsBack = localStorage.getItem('seatlabelback')?.split(',').filter(s => s) || [];

            // Initialize outbound gender array
            this.selected = new Array(seatLabels.length).fill(0);

            // Initialize return trip gender array if needed
            if (this.returnTrip) {
                this.selectedback = new Array(seatLabelsBack.length).fill(0);
            }

            // Set first passenger's gender from profile if available
            const profileGender = localStorage.getItem('genderProfile');
            if (profileGender) {
                const genderValue = parseInt(profileGender);
                if (this.selected.length > 0) {
                    this.selected[0] = genderValue;
                    this.setGender(0, genderValue); // This will handle display text updates
                }
                if (this.returnTrip && this.selectedback.length > 0) {
                    this.selectedback[0] = genderValue;
                    this.setGenderBack(0, genderValue); // This will handle display text updates
                }
            }
        },
        onlyNumber(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const isNumeric = /^[0-9]+$/.test(keyValue);

            if (!isNumeric) {
                event.preventDefault();
            }
        },

        handlePaste(event) {
            // Prevent the default paste
            event.preventDefault();

            // Get pasted data
            const pastedData = (event.clipboardData || window.clipboardData).getData('text');

            // Only keep numbers
            const numbersOnly = pastedData.replace(/[^0-9]/g, '');

            // Update the value respecting maxLength
            const newValue = (this.phone + numbersOnly).slice(0, this.maxLength);
            this.phone = newValue;
        },
    },
    mounted() {
        // this.initializeGenderProfile();
        const storedPromoCode = this.normalizePromoValue(localStorage.getItem('promoCode'));
        const legacyCouponCode = this.normalizePromoValue(localStorage.getItem('couponCode'));
        this.promoCode = storedPromoCode || legacyCouponCode;
        this.promoInput = this.promoCode;
        this.isCouponApplied = !!this.promoCode;

        if (this.promoCode) {
            localStorage.setItem('promoCode', this.promoCode);
        } else {
            localStorage.removeItem('promoCode');
        }

        let phone = localStorage.getItem('telephoneProfile');
        if (phone == null || phone == "undefined" || phone == "null") {
            this.phone = '';
        } else {
            this.phone = String(phone).trim();
        }
        // Check if the user is logged in
        const session = localStorage.getItem('session_start_login');
        this.isLoggedIn = !!session;
        if (session) {
            // Call getNationality if logged in
            this.getNationality();
        }
        this.removefixscroll();
        window.onpopstate = () => {
            if (localStorage.getItem('dateTo') != null) {
                localStorage.removeItem("seatback");
                localStorage.removeItem("seatlabelback");
            } else {
                localStorage.removeItem("seat");
                localStorage.removeItem("seatlabel");
            }
        };
        this.$emit("input", this.selectedBox);
        this.$emit("input", this.selectedBoxDown);
        this.initializeNationality();
        this.getNationality();

        // Add click outside listener
        document.addEventListener('click', this.handleClickOutside);
    },
    created() {
        const session = localStorage.getItem('session_start_login');
        this.isLoggedIn = !!session;

        // Load boarding and drop-off points immediately
        this.loadBoardingAndDropOffPoints();
        this.getCheck();
        this.getSeatLabelRetureBack();

        this.initializePassengerNames();
        this.initializeGenderArrays();
        this.initializeNationality();

        // Only call getNationality if user is logged in
        if (session) {
            // this.getTravelPackageCode();
            this.getNationality();
        }

    }
}
</script>

<style whyscoped>
.hideNational {
    transition: .5s;
    display: none;
}

.trip-details-modal-overlay {
    position: absolute;
    transform: translate(-150%, -150%);
    background-color: #fff;
    /* padding: 20px; */
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1001;
}

.passenger-pd {
    background-color: #F2F2F2;

    padding: 100px 0px 50px 0px;
}

.custom-radio input[type="radio"] {
    appearance: none;
    width: 13px;
    height: 13px;
    border: 1px solid #d83b45;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    cursor: pointer;
    transition: all 0.2s ease;
}

.custom-radio input[type="radio"]:checked {
    border: 6px solid #3b65d8;
}

.custom-radio span {
    font-size: 14px;
    color: #2d2d2d;
}

.showNational {
    display: block;
}

.mtop {
    margin-top: 100px;
    margin-bottom: 50px;
}

.title-booking-detail p {
    font-size: 16px;
    font-weight: 600;
    color: #20292F;
    border-bottom: 1px solid #DADDE1;
}

.custom-checkbox {
    display: inline-block;
    position: relative;
    cursor: pointer;
    user-select: none;
}

.custom-checkbox input {
    position: absolute;
    opacity: 0.6;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 24px;
    width: 24px;
    background-color: #fff;
    border: 2px solid #ccc;
    border-radius: 4px;
}

.checkmark:after {
    content: "";
    position: absolute;
    display: none;
    left: 7px;
    top: 1px;
    width: 7px;
    height: 18px;
    border: solid #4CAF50;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
}

.custom-checkbox input:checked~.checkmark:after {
    display: block;
}

.bg-lights {
    width: 35px;
    height: 35px;
    padding: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #DE5D0A;
    border-radius: 50%;
}

.img-note {
    display: flex;
    align-items: center;
}

.img-note div {
    margin-right: 10px;
}

.bg-lights img {
    width: 85%;
    height: 85%;
    border-radius: 50%;
}

.noted-text {
    margin-top: 14px;
    padding-left: 45px;
}

.name-width {
    margin-left: -25px;
    width: 80%;
}

.map-point-width {
    width: 20%;
}

.map-point-width-left {
    text-align: center;
    width: 13%;
}

/* Right */
.passDetails {
    display: flex;
    align-items: center;
    padding-top: 1rem;
}

.passenger {
    padding-top: 17px;
}

.alert-danger {
    background-color: #FEF0EF;
    color: #FF0000;
    font-size: 14px;
    font-weight: 600;
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding: 1rem;
    /* border-radius: 12px; */
    display: flex;
    align-items: center;
    /* gap: 1rem; */
}

.d-none-for-mobile {
    display: none;
}

@media(width >=960px) {
    .padd-lefe {
        position: sticky;
        top: 90px;
        align-self: flex-start;
    }
}

.passDetails .number {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 600;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid #312783;
    background: #312783;
}

.passDetails .title-pass {
    font-weight: 600;
    font-size: 14px;
    color: #424245;
    padding-bottom: 10px;
}

.custom-input {
    cursor: pointer;
    padding-left: 12px;
    border-radius: 4px;
    width: 99%;
    outline: none;
    border: 1px solid #DADDE1;
    padding: 10px;

}

.border-radius {
    border: 0.5px solid #DC3545 !important;
}

.custom-select .selected.border-radius {
    border: 0.5px solid #DC3545 !important;
}

.select-radio .card-select-payment {
    background: #EEEEF3;
    margin-top: 20px;
    padding: 25px;
    border-radius: 6px;
    display: flex;
    align-items: center;
}

.select-radio .card-select-payment .text .title {
    font-weight: 600;
    font-size: 12px !important;
    color: #424245;
}

.dotted {
    display: none;
    padding-top: 10px;
}

.select-radio .card-select-payment .text .txt {
    font-weight: 400;
    font-size: 12px !important;
    color: #6E6E73;
}

.select-radio .card-select-payment .img-card {
    width: 10%;
}

.select-radio .card-select-payment .text {
    width: 80%;
}

.select-radio .card-select-payment .radios {
    display: flex;
    justify-content: end;
    width: 10%;
}

/* left */
.fare-detail {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    font-size: 16px;
    color: #20292F;
    padding-bottom: 1rem;
}

.d-flexs {
    margin-top: 10px;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
}

.d-flexs .static {
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    width: 36%;
}

.smallLineHeight {
    line-height: 25px;
}

.largeLineHeight {
    line-height: 40px;
}

.d-flexs .dynamic {
    /* margin-left: 5%; */
    font-size: 14px;
    font-weight: 400;
    color: #1D1D1D;
}

.total {
    margin-top: 25px;
    display: flex;
    align-items: center;
    padding: 15px;
    border-radius: 6px;
    background: #D9D9D9;
}

.total div {
    width: 50%;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
}

.total .price {
    text-align: end;
    font-weight: 600;
    font-size: 14px;
    color: #000000;
}

.check-box {
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.check-box .text {
    margin-top: 10px;
}

.promo-code-section {
    margin-top: 14px;
    border-top: 1px solid #DADDE1;
    padding-top: 20px;
    cursor: pointer;
}

.promo-code-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.promo-code-title-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
}

.promo-code-icon {
    color: #DE5D0A;
    font-size: 16px;
}

.promo-code-title {
    color: #20292F;
    font-size: 16px;
    font-weight: 400;
}

.promo-code-inline-input {
    border: none;
    border-radius: 0;
    min-width: 160px;
    text-align: right;
    outline: none;
    color: #6E6E73;
    font-size: 16px;
    margin-bottom: 0px;
}

.promo-code-inline-input:focus {
    border-bottom-color: #DE5D0A;
}

.proccess {
    cursor: pointer;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 15px; */
    border-radius: 6px;
    font-weight: 600;
    color: #fff;
    font-size: 16px;
    background: #DE5D0A;
}

.apply {
    cursor: pointer;
    text-align: center;
    padding: 10px;
    border-radius: 6px;
    font-weight: 600;
    color: #fff;
    font-size: 16px;
    background: #DE5D0A;
}

.theme--light.v-icon {
    color: #C6C6C6 !important;
}

.theme--light.v-input--selection-controls .v-icon {
    color: #C6C6C6 !important;
}

.custom-select {
    margin-top: 0px;
    position: relative;
    width: 100%;
    text-align: left;
    outline: none;
    /* line-height: 24px; */
    padding-top: 5px;
}

.custom-select .selected {
    border-radius: 6px;
    border: 1px solid #DADDE1;
    color: #000;
    padding-left: 1rem;
    cursor: pointer;
    user-select: none;
    padding: 10px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.custom-select .selected.open {
    border-radius: 6px;
}

.header-drop-point {
    color: #1D1D1D;
    cursor: text !important;
    font-size: 18px;
    font-weight: 600;
    padding-bottom: 14px;
    padding-top: 14px;
}

.right-info-name-map {
    border: 1px solid #DADDE1;
    width: 90%;
    border-radius: 8px;
    /* padding: 0px 10px; */
    padding-top: 10px;
    padding-left: 10px;
    /* padding-right: 10px; */
}

.hideAfterdrop:after {
    content: none !important;
}

.custom-select .items {
    color: #000;
    border-radius: 0px 0px 6px 6px;
    overflow: hidden;
    position: absolute;
    background-color: #FFF;
    left: 0;
    right: 0;
    z-index: 1;
    box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
}

.custom-select .items div {
    color: #000;
    padding-left: 1em;
    cursor: pointer;
    user-select: none;
}

.selectHide {
    display: none;
}

.details-screen {
    padding-top: 6px;
}

.proccessed {
    cursor: not-allowed;
    margin-top: 5px;
    text-align: center;
    padding: 15px;
    border-radius: 6px;
    font-weight: 600;
    color: #fff;
    font-size: 16px;
    background: #6A6969;
}

@media(width < 960px) {
    .select-radio {
        padding-left: 0px;
    }

    .select-radio .card-select-payment .text {
        padding-left: 20px;
    }

    .passenger {
        padding-left: 0px;
    }

    .padd-lefe {
        padding-left: 10px;
    }

    .details-screen,
    .passDetails-info {
        /* padding-top: 20px !important; */
    }
}

@media(width < 600px) {
    /* .dotted {
        display: block;
    } */

    .group-form {
        display: flex;
    }

    .equal_label {
        width: 30%;
        display: flex;
        align-items: center;
    }

    .equal_label1 {
        display: flex;
        align-items: center;
    }

    .equals_input {
        width: 100%;
    }

    .passenger-pd {
        padding-top: 100px;
    }

    .smallLineHeight {
        line-height: 25px;
    }

    .largeLineHeight {
        line-height: 25px;
    }

    .map-point-width {
        width: 28%;
    }

    .details-screen {
        /* padding-top: 20px !important; */
    }

    .mobileScreen {
        width: 97%;
        font-size: 14px;
        /* padding-top: 6px; */
    }
}

@media (width < 457px) {
    .select-radio .card-select-payment {
        padding: 8px;
    }

    .promo-code-row {
        flex-direction: column;
        align-items: flex-start;
    }

    .promo-code-inline-input {
        width: 100%;
        text-align: left;
    }
}

@media(width < 435px) {
    .passDetails .title-pass {
        font-size: 13px;
    }
}

@media(width < 400px) {
    .details-screen {
        /* padding-top: 20px !important; */
    }

    .name-width {
        width: 60%;
    }

    .map-point-width {
        width: 40%;
    }
}

@media (width < 450px) {
    .noted-text {
        margin-top: 14px;
        padding-left: 0px;
    }

    .borderround {
        border: 0px !important;
        padding: 0% !important;

    }

    .custom-select {
        border-radius: 5px;
    }

    .mobileScreen {

        width: 96%;
        font-size: 14px;
    }

    .rowScreen {
        margin-bottom: auto !important;
    }

    .custom-select .selected {
        /* line-height: 2; */
        padding: 8px;

    }

    .custom-select .items {
        /* line-height: 2; */
        font-size: 14px;
    }

    .custom-select .selected:after {
        top: 28px;
        font-weight: bold;
    }
}

.v-input--selection-controls__input input[role=checkbox] {
    opacity: 1 !important;
}

.hover-color:hover {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 12px;
    color: #ffffff;
    background: #DE5D0A;
}

.disabled-point {
    cursor: not-allowed;
    pointer-events: none;
}

.custom-checkbox-appy {
    display: inline-block;
    position: relative;
    padding-left: 32px;
    cursor: pointer;
    user-select: none;
    height: 28px;
    width: 28px;
}

.custom-checkbox-appy input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkmark-appy {
    position: absolute;
    top: 0;
    left: 0;
    height: 28px;
    width: 28px;
    background-color: #fff;
    border: 2px solid #C6C6C6;
    border-radius: 6px;
    box-sizing: border-box;
    transition: border-color 0.2s;
}

.checkbox-error {
    border: 2px solid #DC3545 !important;
}

.custom-checkbox-appy input:checked~.checkmark-appy {
    background-color: #fff;
    border: 2px solid #C6C6C6;
}

.checkmark-appy:after {
    content: "";
    position: absolute;
    display: none;
    left: 7px;
    top: 2px;
    width: 10px;
    height: 16px;
    border: solid #DE5D0A;
    border-width: 0 3px 3px 0;
    border-radius: 1px;
    transform: rotate(45deg);
}

.custom-checkbox-appy input:checked~.checkmark-appy:after {
    display: block;
}

.loader {
    width: 24px;
    height: 24px;
    border: 3px solid #fff;
    border-bottom-color: transparent;
    border-radius: 50%;
    padding: 5px;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* 
@keyframes l13 {
    100% {
        transform: rotate(1turn);
    }
} */
</style>